import { o as Hu, s as wu } from "./default-C3m3V4yx.js";
class ie {
  constructor(t, u, s) {
    this.property = t, this.normal = u, s && (this.space = s);
  }
}
ie.prototype.property = {}, ie.prototype.normal = {}, ie.prototype.space = null;
function Ut(e, t) {
  const u = {}, s = {};
  let r = -1;
  for (; ++r < e.length; )
    Object.assign(u, e[r].property), Object.assign(s, e[r].normal);
  return new ie(u, s, t);
}
function Te(e) {
  return e.toLowerCase();
}
class x {
  constructor(t, u) {
    this.property = t, this.attribute = u;
  }
}
x.prototype.space = null, x.prototype.boolean = !1, x.prototype.booleanish = !1, x.prototype.overloadedBoolean = !1, x.prototype.number = !1, x.prototype.commaSeparated = !1, x.prototype.spaceSeparated = !1, x.prototype.commaOrSpaceSeparated = !1, x.prototype.mustUseProperty = !1, x.prototype.defined = !1;
let Gu = 0;
const _ = K(), N = K(), Ht = K(), C = K(), B = K(), $ = K(), b = K();
function K() {
  return 2 ** ++Gu;
}
const Ye = Object.freeze(Object.defineProperty({ __proto__: null, boolean: _, booleanish: N, commaOrSpaceSeparated: b, commaSeparated: $, number: C, overloadedBoolean: Ht, spaceSeparated: B }, Symbol.toStringTag, { value: "Module" })), Pe = Object.keys(Ye);
class je extends x {
  constructor(t, u, s, r) {
    let o = -1;
    if (super(t, u), lt(this, "space", r), typeof s == "number")
      for (; ++o < Pe.length; ) {
        const E = Pe[o];
        lt(this, Pe[o], (s & Ye[E]) === Ye[E]);
      }
  }
}
je.prototype.defined = !0;
function lt(e, t, u) {
  u && (e[t] = u);
}
const vu = {}.hasOwnProperty;
function te(e) {
  const t = {}, u = {};
  let s;
  for (s in e.properties)
    if (vu.call(e.properties, s)) {
      const r = e.properties[s], o = new je(s, e.transform(e.attributes || {}, s), r, e.space);
      e.mustUseProperty && e.mustUseProperty.includes(s) && (o.mustUseProperty = !0), t[s] = o, u[Te(s)] = s, u[Te(o.attribute)] = s;
    }
  return new ie(t, u, e.space);
}
const wt = te({ space: "xlink", transform(e, t) {
  return "xlink:" + t.slice(5).toLowerCase();
}, properties: { xLinkActuate: null, xLinkArcRole: null, xLinkHref: null, xLinkRole: null, xLinkShow: null, xLinkTitle: null, xLinkType: null } }), Gt = te({ space: "xml", transform(e, t) {
  return "xml:" + t.slice(3).toLowerCase();
}, properties: { xmlLang: null, xmlBase: null, xmlSpace: null } });
function vt(e, t) {
  return t in e ? e[t] : t;
}
function Yt(e, t) {
  return vt(e, t.toLowerCase());
}
const qt = te({ space: "xmlns", attributes: { xmlnsxlink: "xmlns:xlink" }, transform: Yt, properties: { xmlns: null, xmlnsXLink: null } }), Wt = te({ transform(e, t) {
  return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
}, properties: { ariaActiveDescendant: null, ariaAtomic: N, ariaAutoComplete: null, ariaBusy: N, ariaChecked: N, ariaColCount: C, ariaColIndex: C, ariaColSpan: C, ariaControls: B, ariaCurrent: null, ariaDescribedBy: B, ariaDetails: null, ariaDisabled: N, ariaDropEffect: B, ariaErrorMessage: null, ariaExpanded: N, ariaFlowTo: B, ariaGrabbed: N, ariaHasPopup: null, ariaHidden: N, ariaInvalid: null, ariaKeyShortcuts: null, ariaLabel: null, ariaLabelledBy: B, ariaLevel: C, ariaLive: null, ariaModal: N, ariaMultiLine: N, ariaMultiSelectable: N, ariaOrientation: null, ariaOwns: B, ariaPlaceholder: null, ariaPosInSet: C, ariaPressed: N, ariaReadOnly: N, ariaRelevant: null, ariaRequired: N, ariaRoleDescription: B, ariaRowCount: C, ariaRowIndex: C, ariaRowSpan: C, ariaSelected: N, ariaSetSize: C, ariaSort: null, ariaValueMax: C, ariaValueMin: C, ariaValueNow: C, ariaValueText: null, role: null } }), Yu = te({ space: "html", attributes: { acceptcharset: "accept-charset", classname: "class", htmlfor: "for", httpequiv: "http-equiv" }, transform: Yt, mustUseProperty: ["checked", "multiple", "muted", "selected"], properties: { abbr: null, accept: $, acceptCharset: B, accessKey: B, action: null, allow: null, allowFullScreen: _, allowPaymentRequest: _, allowUserMedia: _, alt: null, as: null, async: _, autoCapitalize: null, autoComplete: B, autoFocus: _, autoPlay: _, blocking: B, capture: null, charSet: null, checked: _, cite: null, className: B, cols: C, colSpan: null, content: null, contentEditable: N, controls: _, controlsList: B, coords: C | $, crossOrigin: null, data: null, dateTime: null, decoding: null, default: _, defer: _, dir: null, dirName: null, disabled: _, download: Ht, draggable: N, encType: null, enterKeyHint: null, fetchPriority: null, form: null, formAction: null, formEncType: null, formMethod: null, formNoValidate: _, formTarget: null, headers: B, height: C, hidden: _, high: C, href: null, hrefLang: null, htmlFor: B, httpEquiv: B, id: null, imageSizes: null, imageSrcSet: null, inert: _, inputMode: null, integrity: null, is: null, isMap: _, itemId: null, itemProp: B, itemRef: B, itemScope: _, itemType: B, kind: null, label: null, lang: null, language: null, list: null, loading: null, loop: _, low: C, manifest: null, max: null, maxLength: C, media: null, method: null, min: null, minLength: C, multiple: _, muted: _, name: null, nonce: null, noModule: _, noValidate: _, onAbort: null, onAfterPrint: null, onAuxClick: null, onBeforeMatch: null, onBeforePrint: null, onBeforeToggle: null, onBeforeUnload: null, onBlur: null, onCancel: null, onCanPlay: null, onCanPlayThrough: null, onChange: null, onClick: null, onClose: null, onContextLost: null, onContextMenu: null, onContextRestored: null, onCopy: null, onCueChange: null, onCut: null, onDblClick: null, onDrag: null, onDragEnd: null, onDragEnter: null, onDragExit: null, onDragLeave: null, onDragOver: null, onDragStart: null, onDrop: null, onDurationChange: null, onEmptied: null, onEnded: null, onError: null, onFocus: null, onFormData: null, onHashChange: null, onInput: null, onInvalid: null, onKeyDown: null, onKeyPress: null, onKeyUp: null, onLanguageChange: null, onLoad: null, onLoadedData: null, onLoadedMetadata: null, onLoadEnd: null, onLoadStart: null, onMessage: null, onMessageError: null, onMouseDown: null, onMouseEnter: null, onMouseLeave: null, onMouseMove: null, onMouseOut: null, onMouseOver: null, onMouseUp: null, onOffline: null, onOnline: null, onPageHide: null, onPageShow: null, onPaste: null, onPause: null, onPlay: null, onPlaying: null, onPopState: null, onProgress: null, onRateChange: null, onRejectionHandled: null, onReset: null, onResize: null, onScroll: null, onScrollEnd: null, onSecurityPolicyViolation: null, onSeeked: null, onSeeking: null, onSelect: null, onSlotChange: null, onStalled: null, onStorage: null, onSubmit: null, onSuspend: null, onTimeUpdate: null, onToggle: null, onUnhandledRejection: null, onUnload: null, onVolumeChange: null, onWaiting: null, onWheel: null, open: _, optimum: C, pattern: null, ping: B, placeholder: null, playsInline: _, popover: null, popoverTarget: null, popoverTargetAction: null, poster: null, preload: null, readOnly: _, referrerPolicy: null, rel: B, required: _, reversed: _, rows: C, rowSpan: C, sandbox: B, scope: null, scoped: _, seamless: _, selected: _, shadowRootDelegatesFocus: _, shadowRootMode: null, shape: null, size: C, sizes: null, slot: null, span: C, spellCheck: N, src: null, srcDoc: null, srcLang: null, srcSet: null, start: C, step: null, style: null, tabIndex: C, target: null, title: null, translate: null, type: null, typeMustMatch: _, useMap: null, value: N, width: C, wrap: null, align: null, aLink: null, archive: B, axis: null, background: null, bgColor: null, border: C, borderColor: null, bottomMargin: C, cellPadding: null, cellSpacing: null, char: null, charOff: null, classId: null, clear: null, code: null, codeBase: null, codeType: null, color: null, compact: _, declare: _, event: null, face: null, frame: null, frameBorder: null, hSpace: C, leftMargin: C, link: null, longDesc: null, lowSrc: null, marginHeight: C, marginWidth: C, noResize: _, noHref: _, noShade: _, noWrap: _, object: null, profile: null, prompt: null, rev: null, rightMargin: C, rules: null, scheme: null, scrolling: N, standby: null, summary: null, text: null, topMargin: C, valueType: null, version: null, vAlign: null, vLink: null, vSpace: C, allowTransparency: null, autoCorrect: null, autoSave: null, disablePictureInPicture: _, disableRemotePlayback: _, prefix: null, property: null, results: C, security: null, unselectable: null } }), qu = te({ space: "svg", attributes: { accentHeight: "accent-height", alignmentBaseline: "alignment-baseline", arabicForm: "arabic-form", baselineShift: "baseline-shift", capHeight: "cap-height", className: "class", clipPath: "clip-path", clipRule: "clip-rule", colorInterpolation: "color-interpolation", colorInterpolationFilters: "color-interpolation-filters", colorProfile: "color-profile", colorRendering: "color-rendering", crossOrigin: "crossorigin", dataType: "datatype", dominantBaseline: "dominant-baseline", enableBackground: "enable-background", fillOpacity: "fill-opacity", fillRule: "fill-rule", floodColor: "flood-color", floodOpacity: "flood-opacity", fontFamily: "font-family", fontSize: "font-size", fontSizeAdjust: "font-size-adjust", fontStretch: "font-stretch", fontStyle: "font-style", fontVariant: "font-variant", fontWeight: "font-weight", glyphName: "glyph-name", glyphOrientationHorizontal: "glyph-orientation-horizontal", glyphOrientationVertical: "glyph-orientation-vertical", hrefLang: "hreflang", horizAdvX: "horiz-adv-x", horizOriginX: "horiz-origin-x", horizOriginY: "horiz-origin-y", imageRendering: "image-rendering", letterSpacing: "letter-spacing", lightingColor: "lighting-color", markerEnd: "marker-end", markerMid: "marker-mid", markerStart: "marker-start", navDown: "nav-down", navDownLeft: "nav-down-left", navDownRight: "nav-down-right", navLeft: "nav-left", navNext: "nav-next", navPrev: "nav-prev", navRight: "nav-right", navUp: "nav-up", navUpLeft: "nav-up-left", navUpRight: "nav-up-right", onAbort: "onabort", onActivate: "onactivate", onAfterPrint: "onafterprint", onBeforePrint: "onbeforeprint", onBegin: "onbegin", onCancel: "oncancel", onCanPlay: "oncanplay", onCanPlayThrough: "oncanplaythrough", onChange: "onchange", onClick: "onclick", onClose: "onclose", onCopy: "oncopy", onCueChange: "oncuechange", onCut: "oncut", onDblClick: "ondblclick", onDrag: "ondrag", onDragEnd: "ondragend", onDragEnter: "ondragenter", onDragExit: "ondragexit", onDragLeave: "ondragleave", onDragOver: "ondragover", onDragStart: "ondragstart", onDrop: "ondrop", onDurationChange: "ondurationchange", onEmptied: "onemptied", onEnd: "onend", onEnded: "onended", onError: "onerror", onFocus: "onfocus", onFocusIn: "onfocusin", onFocusOut: "onfocusout", onHashChange: "onhashchange", onInput: "oninput", onInvalid: "oninvalid", onKeyDown: "onkeydown", onKeyPress: "onkeypress", onKeyUp: "onkeyup", onLoad: "onload", onLoadedData: "onloadeddata", onLoadedMetadata: "onloadedmetadata", onLoadStart: "onloadstart", onMessage: "onmessage", onMouseDown: "onmousedown", onMouseEnter: "onmouseenter", onMouseLeave: "onmouseleave", onMouseMove: "onmousemove", onMouseOut: "onmouseout", onMouseOver: "onmouseover", onMouseUp: "onmouseup", onMouseWheel: "onmousewheel", onOffline: "onoffline", onOnline: "ononline", onPageHide: "onpagehide", onPageShow: "onpageshow", onPaste: "onpaste", onPause: "onpause", onPlay: "onplay", onPlaying: "onplaying", onPopState: "onpopstate", onProgress: "onprogress", onRateChange: "onratechange", onRepeat: "onrepeat", onReset: "onreset", onResize: "onresize", onScroll: "onscroll", onSeeked: "onseeked", onSeeking: "onseeking", onSelect: "onselect", onShow: "onshow", onStalled: "onstalled", onStorage: "onstorage", onSubmit: "onsubmit", onSuspend: "onsuspend", onTimeUpdate: "ontimeupdate", onToggle: "ontoggle", onUnload: "onunload", onVolumeChange: "onvolumechange", onWaiting: "onwaiting", onZoom: "onzoom", overlinePosition: "overline-position", overlineThickness: "overline-thickness", paintOrder: "paint-order", panose1: "panose-1", pointerEvents: "pointer-events", referrerPolicy: "referrerpolicy", renderingIntent: "rendering-intent", shapeRendering: "shape-rendering", stopColor: "stop-color", stopOpacity: "stop-opacity", strikethroughPosition: "strikethrough-position", strikethroughThickness: "strikethrough-thickness", strokeDashArray: "stroke-dasharray", strokeDashOffset: "stroke-dashoffset", strokeLineCap: "stroke-linecap", strokeLineJoin: "stroke-linejoin", strokeMiterLimit: "stroke-miterlimit", strokeOpacity: "stroke-opacity", strokeWidth: "stroke-width", tabIndex: "tabindex", textAnchor: "text-anchor", textDecoration: "text-decoration", textRendering: "text-rendering", transformOrigin: "transform-origin", typeOf: "typeof", underlinePosition: "underline-position", underlineThickness: "underline-thickness", unicodeBidi: "unicode-bidi", unicodeRange: "unicode-range", unitsPerEm: "units-per-em", vAlphabetic: "v-alphabetic", vHanging: "v-hanging", vIdeographic: "v-ideographic", vMathematical: "v-mathematical", vectorEffect: "vector-effect", vertAdvY: "vert-adv-y", vertOriginX: "vert-origin-x", vertOriginY: "vert-origin-y", wordSpacing: "word-spacing", writingMode: "writing-mode", xHeight: "x-height", playbackOrder: "playbackorder", timelineBegin: "timelinebegin" }, transform: vt, properties: { about: b, accentHeight: C, accumulate: null, additive: null, alignmentBaseline: null, alphabetic: C, amplitude: C, arabicForm: null, ascent: C, attributeName: null, attributeType: null, azimuth: C, bandwidth: null, baselineShift: null, baseFrequency: null, baseProfile: null, bbox: null, begin: null, bias: C, by: null, calcMode: null, capHeight: C, className: B, clip: null, clipPath: null, clipPathUnits: null, clipRule: null, color: null, colorInterpolation: null, colorInterpolationFilters: null, colorProfile: null, colorRendering: null, content: null, contentScriptType: null, contentStyleType: null, crossOrigin: null, cursor: null, cx: null, cy: null, d: null, dataType: null, defaultAction: null, descent: C, diffuseConstant: C, direction: null, display: null, dur: null, divisor: C, dominantBaseline: null, download: _, dx: null, dy: null, edgeMode: null, editable: null, elevation: C, enableBackground: null, end: null, event: null, exponent: C, externalResourcesRequired: null, fill: null, fillOpacity: C, fillRule: null, filter: null, filterRes: null, filterUnits: null, floodColor: null, floodOpacity: null, focusable: null, focusHighlight: null, fontFamily: null, fontSize: null, fontSizeAdjust: null, fontStretch: null, fontStyle: null, fontVariant: null, fontWeight: null, format: null, fr: null, from: null, fx: null, fy: null, g1: $, g2: $, glyphName: $, glyphOrientationHorizontal: null, glyphOrientationVertical: null, glyphRef: null, gradientTransform: null, gradientUnits: null, handler: null, hanging: C, hatchContentUnits: null, hatchUnits: null, height: null, href: null, hrefLang: null, horizAdvX: C, horizOriginX: C, horizOriginY: C, id: null, ideographic: C, imageRendering: null, initialVisibility: null, in: null, in2: null, intercept: C, k: C, k1: C, k2: C, k3: C, k4: C, kernelMatrix: b, kernelUnitLength: null, keyPoints: null, keySplines: null, keyTimes: null, kerning: null, lang: null, lengthAdjust: null, letterSpacing: null, lightingColor: null, limitingConeAngle: C, local: null, markerEnd: null, markerMid: null, markerStart: null, markerHeight: null, markerUnits: null, markerWidth: null, mask: null, maskContentUnits: null, maskUnits: null, mathematical: null, max: null, media: null, mediaCharacterEncoding: null, mediaContentEncodings: null, mediaSize: C, mediaTime: null, method: null, min: null, mode: null, name: null, navDown: null, navDownLeft: null, navDownRight: null, navLeft: null, navNext: null, navPrev: null, navRight: null, navUp: null, navUpLeft: null, navUpRight: null, numOctaves: null, observer: null, offset: null, onAbort: null, onActivate: null, onAfterPrint: null, onBeforePrint: null, onBegin: null, onCancel: null, onCanPlay: null, onCanPlayThrough: null, onChange: null, onClick: null, onClose: null, onCopy: null, onCueChange: null, onCut: null, onDblClick: null, onDrag: null, onDragEnd: null, onDragEnter: null, onDragExit: null, onDragLeave: null, onDragOver: null, onDragStart: null, onDrop: null, onDurationChange: null, onEmptied: null, onEnd: null, onEnded: null, onError: null, onFocus: null, onFocusIn: null, onFocusOut: null, onHashChange: null, onInput: null, onInvalid: null, onKeyDown: null, onKeyPress: null, onKeyUp: null, onLoad: null, onLoadedData: null, onLoadedMetadata: null, onLoadStart: null, onMessage: null, onMouseDown: null, onMouseEnter: null, onMouseLeave: null, onMouseMove: null, onMouseOut: null, onMouseOver: null, onMouseUp: null, onMouseWheel: null, onOffline: null, onOnline: null, onPageHide: null, onPageShow: null, onPaste: null, onPause: null, onPlay: null, onPlaying: null, onPopState: null, onProgress: null, onRateChange: null, onRepeat: null, onReset: null, onResize: null, onScroll: null, onSeeked: null, onSeeking: null, onSelect: null, onShow: null, onStalled: null, onStorage: null, onSubmit: null, onSuspend: null, onTimeUpdate: null, onToggle: null, onUnload: null, onVolumeChange: null, onWaiting: null, onZoom: null, opacity: null, operator: null, order: null, orient: null, orientation: null, origin: null, overflow: null, overlay: null, overlinePosition: C, overlineThickness: C, paintOrder: null, panose1: null, path: null, pathLength: C, patternContentUnits: null, patternTransform: null, patternUnits: null, phase: null, ping: B, pitch: null, playbackOrder: null, pointerEvents: null, points: null, pointsAtX: C, pointsAtY: C, pointsAtZ: C, preserveAlpha: null, preserveAspectRatio: null, primitiveUnits: null, propagate: null, property: b, r: null, radius: null, referrerPolicy: null, refX: null, refY: null, rel: b, rev: b, renderingIntent: null, repeatCount: null, repeatDur: null, requiredExtensions: b, requiredFeatures: b, requiredFonts: b, requiredFormats: b, resource: null, restart: null, result: null, rotate: null, rx: null, ry: null, scale: null, seed: null, shapeRendering: null, side: null, slope: null, snapshotTime: null, specularConstant: C, specularExponent: C, spreadMethod: null, spacing: null, startOffset: null, stdDeviation: null, stemh: null, stemv: null, stitchTiles: null, stopColor: null, stopOpacity: null, strikethroughPosition: C, strikethroughThickness: C, string: null, stroke: null, strokeDashArray: b, strokeDashOffset: null, strokeLineCap: null, strokeLineJoin: null, strokeMiterLimit: C, strokeOpacity: C, strokeWidth: null, style: null, surfaceScale: C, syncBehavior: null, syncBehaviorDefault: null, syncMaster: null, syncTolerance: null, syncToleranceDefault: null, systemLanguage: b, tabIndex: C, tableValues: null, target: null, targetX: C, targetY: C, textAnchor: null, textDecoration: null, textRendering: null, textLength: null, timelineBegin: null, title: null, transformBehavior: null, type: null, typeOf: b, to: null, transform: null, transformOrigin: null, u1: null, u2: null, underlinePosition: C, underlineThickness: C, unicode: null, unicodeBidi: null, unicodeRange: null, unitsPerEm: C, values: null, vAlphabetic: C, vMathematical: C, vectorEffect: null, vHanging: C, vIdeographic: C, version: null, vertAdvY: C, vertOriginX: C, vertOriginY: C, viewBox: null, viewTarget: null, visibility: null, width: null, widths: null, wordSpacing: null, writingMode: null, x: null, x1: null, x2: null, xChannelSelector: null, xHeight: C, y: null, y1: null, y2: null, yChannelSelector: null, z: null, zoomAndPan: null } }), Wu = /^data[-\w.:]+$/i, At = /-[a-z]/g, Qu = /[A-Z]/g;
function Qt(e, t) {
  const u = Te(t);
  let s = t, r = x;
  if (u in e.normal)
    return e.property[e.normal[u]];
  if (u.length > 4 && u.slice(0, 4) === "data" && Wu.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(At, Ku);
      s = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!At.test(o)) {
        let E = o.replace(Qu, Xu);
        E.charAt(0) !== "-" && (E = "-" + E), t = "data" + E;
      }
    }
    r = je;
  }
  return new r(s, t);
}
function Xu(e) {
  return "-" + e.toLowerCase();
}
function Ku(e) {
  return e.charAt(1).toUpperCase();
}
const Je = Ut([Gt, wt, qt, Wt, Yu], "html"), Ze = Ut([Gt, wt, qt, Wt, qu], "svg");
function ht(e) {
  const t = [], u = String(e || "");
  let s = u.indexOf(","), r = 0, o = !1;
  for (; !o; ) {
    s === -1 && (s = u.length, o = !0);
    const E = u.slice(r, s).trim();
    (E || !o) && t.push(E), r = s + 1, s = u.indexOf(",", r);
  }
  return t;
}
const Tt = /[#.]/g;
function Vu(e, t) {
  const u = e || "", s = {};
  let r = 0, o, E;
  for (; r < u.length; ) {
    Tt.lastIndex = r;
    const T = Tt.exec(u), p = u.slice(r, T ? T.index : u.length);
    p && (o ? o === "#" ? s.id = p : Array.isArray(s.className) ? s.className.push(p) : s.className = [p] : E = p, r += p.length), T && (o = T[0], r++);
  }
  return { type: "element", tagName: E || t || "div", properties: s, children: [] };
}
function pt(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
const zu = /* @__PURE__ */ new Set(["button", "menu", "reset", "submit"]), qe = {}.hasOwnProperty;
function Xt(e, t, u) {
  const s = u && $u(u);
  function r(o, E, ...T) {
    let p = -1, D;
    if (o == null) {
      D = { type: "root", children: [] };
      const m = E;
      T.unshift(m);
    } else if (D = Vu(o, t), D.tagName = D.tagName.toLowerCase(), s && qe.call(s, D.tagName) && (D.tagName = s[D.tagName]), ju(E, D.tagName)) {
      let m;
      for (m in E)
        qe.call(E, m) && Ju(e, D.properties, m, E[m]);
    } else
      T.unshift(E);
    for (; ++p < T.length; )
      We(D.children, T[p]);
    return D.type === "element" && D.tagName === "template" && (D.content = { type: "root", children: D.children }, D.children = []), D;
  }
  return r;
}
function ju(e, t) {
  return e == null || typeof e != "object" || Array.isArray(e) ? !1 : t === "input" || !e.type || typeof e.type != "string" ? !0 : "children" in e && Array.isArray(e.children) ? !1 : t === "button" ? zu.has(e.type.toLowerCase()) : !("value" in e);
}
function Ju(e, t, u, s) {
  const r = Qt(e, u);
  let o = -1, E;
  if (s != null) {
    if (typeof s == "number") {
      if (Number.isNaN(s))
        return;
      E = s;
    } else
      typeof s == "boolean" ? E = s : typeof s == "string" ? r.spaceSeparated ? E = pt(s) : r.commaSeparated ? E = ht(s) : r.commaOrSpaceSeparated ? E = pt(ht(s).join(" ")) : E = dt(r, r.property, s) : Array.isArray(s) ? E = s.concat() : E = r.property === "style" ? Zu(s) : String(s);
    if (Array.isArray(E)) {
      const T = [];
      for (; ++o < E.length; ) {
        const p = dt(r, r.property, E[o]);
        T[o] = p;
      }
      E = T;
    }
    if (r.property === "className" && Array.isArray(t.className)) {
      const T = E;
      E = t.className.concat(T);
    }
    t[r.property] = E;
  }
}
function We(e, t) {
  let u = -1;
  if (t != null)
    if (typeof t == "string" || typeof t == "number")
      e.push({ type: "text", value: String(t) });
    else if (Array.isArray(t))
      for (; ++u < t.length; )
        We(e, t[u]);
    else if (typeof t == "object" && "type" in t)
      t.type === "root" ? We(e, t.children) : e.push(t);
    else
      throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function dt(e, t, u) {
  if (typeof u == "string") {
    if (e.number && u && !Number.isNaN(Number(u)))
      return Number(u);
    if ((e.boolean || e.overloadedBoolean) && (u === "" || Te(u) === Te(t)))
      return !0;
  }
  return u;
}
function Zu(e) {
  const t = [];
  let u;
  for (u in e)
    qe.call(e, u) && t.push([u, e[u]].join(": "));
  return t.join("; ");
}
function $u(e) {
  const t = {};
  let u = -1;
  for (; ++u < e.length; )
    t[e[u].toLowerCase()] = e[u];
  return t;
}
const en = ["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "solidColor", "textArea", "textPath"], tn = Xt(Je, "div"), un = Xt(Ze, "g", en), xe = /\r?\n|\r/g;
function nn(e) {
  const t = String(e), u = [];
  for (xe.lastIndex = 0; xe.test(t); )
    u.push(xe.lastIndex);
  return u.push(t.length + 1), { toPoint: s, toOffset: r };
  function s(o) {
    let E = -1;
    if (typeof o == "number" && o > -1 && o < u[u.length - 1]) {
      for (; ++E < u.length; )
        if (u[E] > o)
          return { line: E + 1, column: o - (E > 0 ? u[E - 1] : 0) + 1, offset: o };
    }
  }
  function r(o) {
    const E = o && o.line, T = o && o.column;
    if (typeof E == "number" && typeof T == "number" && !Number.isNaN(E) && !Number.isNaN(T) && E - 1 in u) {
      const p = (u[E - 2] || 0) + T - 1 || 0;
      if (p > -1 && p < u[u.length - 1])
        return p;
    }
  }
}
const sn = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg", xlink: "http://www.w3.org/1999/xlink", xml: "http://www.w3.org/XML/1998/namespace", xmlns: "http://www.w3.org/2000/xmlns/" }, Kt = {}.hasOwnProperty, an = Object.prototype;
function rn(e, t) {
  const u = t || {};
  return $e({ file: u.file || void 0, location: !1, schema: u.space === "svg" ? Ze : Je, verbose: u.verbose || !1 }, e);
}
function $e(e, t) {
  let u;
  switch (t.nodeName) {
    case "#comment": {
      const s = t;
      return u = { type: "comment", value: s.data }, Be(e, s, u), u;
    }
    case "#document":
    case "#document-fragment": {
      const s = t, r = "mode" in s ? s.mode === "quirks" || s.mode === "limited-quirks" : !1;
      if (u = { type: "root", children: Vt(e, t.childNodes), data: { quirksMode: r } }, e.file && e.location) {
        const o = String(e.file), E = nn(o), T = E.toPoint(0), p = E.toPoint(o.length);
        u.position = { start: T, end: p };
      }
      return u;
    }
    case "#documentType": {
      const s = t;
      return u = { type: "doctype" }, Be(e, s, u), u;
    }
    case "#text": {
      const s = t;
      return u = { type: "text", value: s.value }, Be(e, s, u), u;
    }
    default:
      return u = on(e, t), u;
  }
}
function Vt(e, t) {
  let u = -1;
  const s = [];
  for (; ++u < t.length; ) {
    const r = $e(e, t[u]);
    s.push(r);
  }
  return s;
}
function on(e, t) {
  const u = e.schema;
  e.schema = t.namespaceURI === sn.svg ? Ze : Je;
  let s = -1;
  const r = {};
  for (; ++s < t.attrs.length; ) {
    const E = t.attrs[s], T = (E.prefix ? E.prefix + ":" : "") + E.name;
    Kt.call(an, T) || (r[T] = E.value);
  }
  const o = (e.schema.space === "svg" ? un : tn)(t.tagName, r, Vt(e, t.childNodes));
  if (Be(e, t, o), o.tagName === "template") {
    const E = t, T = E.sourceCodeLocation, p = T && T.startTag && Z(T.startTag), D = T && T.endTag && Z(T.endTag), m = $e(e, E.content);
    p && D && e.file && (m.position = { start: p.end, end: D.start }), o.content = m;
  }
  return e.schema = u, o;
}
function Be(e, t, u) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const s = cn(e, u, t.sourceCodeLocation);
    s && (e.location = !0, u.position = s);
  }
}
function cn(e, t, u) {
  const s = Z(u);
  if (t.type === "element") {
    const r = t.children[t.children.length - 1];
    if (s && !u.endTag && r && r.position && r.position.end && (s.end = Object.assign({}, r.position.end)), e.verbose) {
      const o = {};
      let E;
      if (u.attrs)
        for (E in u.attrs)
          Kt.call(u.attrs, E) && (o[Qt(e.schema, E).property] = Z(u.attrs[E]));
      Hu(u.startTag);
      const T = Z(u.startTag), p = u.endTag ? Z(u.endTag) : void 0, D = { opening: T };
      p && (D.closing = p), D.properties = o, t.data = { position: D };
    }
  }
  return s;
}
function Z(e) {
  const t = Ct({ line: e.startLine, column: e.startCol, offset: e.startOffset }), u = Ct({ line: e.endLine, column: e.endCol, offset: e.endOffset });
  return t || u ? { start: t, end: u } : void 0;
}
function Ct(e) {
  return e.line && e.column ? e : void 0;
}
const En = /* @__PURE__ */ new Set([65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111]), I = "�";
var a;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.NUMBER_SIGN = 35] = "NUMBER_SIGN", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_F = 70] = "LATIN_CAPITAL_F", e[e.LATIN_CAPITAL_X = 88] = "LATIN_CAPITAL_X", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_F = 102] = "LATIN_SMALL_F", e[e.LATIN_SMALL_X = 120] = "LATIN_SMALL_X", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z", e[e.REPLACEMENT_CHARACTER = 65533] = "REPLACEMENT_CHARACTER";
})(a = a || (a = {}));
const L = { DASH_DASH: "--", CDATA_START: "[CDATA[", DOCTYPE: "doctype", SCRIPT: "script", PUBLIC: "public", SYSTEM: "system" };
function zt(e) {
  return e >= 55296 && e <= 57343;
}
function ln(e) {
  return e >= 56320 && e <= 57343;
}
function An(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
}
function jt(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function Jt(e) {
  return e >= 64976 && e <= 65007 || En.has(e);
}
var A;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(A = A || (A = {}));
const hn = 65536;
class Tn {
  constructor(t) {
    this.handler = t, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = hn, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(t) {
    const { line: u, col: s, offset: r } = this;
    return { code: t, startLine: u, endLine: u, startCol: s, endCol: s, startOffset: r, endOffset: r };
  }
  _err(t) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(t)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.html.length - 1) {
      const u = this.html.charCodeAt(this.pos + 1);
      if (ln(u))
        return this.pos++, this._addGap(), An(t, u);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, a.EOF;
    return this._err(A.surrogateInInputStream), t;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(t, u) {
    this.html.length > 0 ? this.html += t : this.html = t, this.endOfChunkHit = !1, this.lastChunkWritten = u;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(t, u) {
    if (this.pos + t.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (u)
      return this.html.startsWith(t, this.pos);
    for (let s = 0; s < t.length; s++)
      if ((this.html.charCodeAt(this.pos + s) | 32) !== t.charCodeAt(s))
        return !1;
    return !0;
  }
  peek(t) {
    const u = this.pos + t;
    if (u >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, a.EOF;
    const s = this.html.charCodeAt(u);
    return s === a.CARRIAGE_RETURN ? a.LINE_FEED : s;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, a.EOF;
    let t = this.html.charCodeAt(this.pos);
    return t === a.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, a.LINE_FEED) : t === a.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, zt(t) && (t = this._processSurrogate(t)), this.handler.onParseError === null || t > 31 && t < 127 || t === a.LINE_FEED || t === a.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    jt(t) ? this._err(A.controlCharacterInInputStream) : Jt(t) && this._err(A.noncharacterInInputStream);
  }
  retreat(t) {
    for (this.pos -= t; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var f;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})(f = f || (f = {}));
function Zt(e, t) {
  for (let u = e.attrs.length - 1; u >= 0; u--)
    if (e.attrs[u].name === t)
      return e.attrs[u].value;
  return null;
}
const v = new Uint16Array('ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))), pn = new Uint16Array("Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((e) => e.charCodeAt(0)));
var ye;
const dn = /* @__PURE__ */ new Map([[0, 65533], [128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]), Cn = (ye = String.fromCodePoint) !== null && ye !== void 0 ? ye : function(e) {
  let t = "";
  return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), t += String.fromCharCode(e), t;
};
function Dn(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = dn.get(e)) !== null && t !== void 0 ? t : e;
}
var g;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(g || (g = {}));
const mn = 32;
var w;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(w || (w = {}));
function Qe(e) {
  return e >= g.ZERO && e <= g.NINE;
}
function _n(e) {
  return e >= g.UPPER_A && e <= g.UPPER_F || e >= g.LOWER_A && e <= g.LOWER_F;
}
function fn(e) {
  return e >= g.UPPER_A && e <= g.UPPER_Z || e >= g.LOWER_A && e <= g.LOWER_Z || Qe(e);
}
function Bn(e) {
  return e === g.EQUALS || fn(e);
}
var S;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(S || (S = {}));
var X;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(X || (X = {}));
class In {
  constructor(t, u, s) {
    this.decodeTree = t, this.emitCodePoint = u, this.errors = s, this.state = S.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = X.Strict;
  }
  startEntity(t) {
    this.decodeMode = t, this.state = S.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  write(t, u) {
    switch (this.state) {
      case S.EntityStart:
        return t.charCodeAt(u) === g.NUM ? (this.state = S.NumericStart, this.consumed += 1, this.stateNumericStart(t, u + 1)) : (this.state = S.NamedEntity, this.stateNamedEntity(t, u));
      case S.NumericStart:
        return this.stateNumericStart(t, u);
      case S.NumericDecimal:
        return this.stateNumericDecimal(t, u);
      case S.NumericHex:
        return this.stateNumericHex(t, u);
      case S.NamedEntity:
        return this.stateNamedEntity(t, u);
    }
  }
  stateNumericStart(t, u) {
    return u >= t.length ? -1 : (t.charCodeAt(u) | mn) === g.LOWER_X ? (this.state = S.NumericHex, this.consumed += 1, this.stateNumericHex(t, u + 1)) : (this.state = S.NumericDecimal, this.stateNumericDecimal(t, u));
  }
  addToNumericResult(t, u, s, r) {
    if (u !== s) {
      const o = s - u;
      this.result = this.result * Math.pow(r, o) + parseInt(t.substr(u, o), r), this.consumed += o;
    }
  }
  stateNumericHex(t, u) {
    const s = u;
    for (; u < t.length; ) {
      const r = t.charCodeAt(u);
      if (Qe(r) || _n(r))
        u += 1;
      else
        return this.addToNumericResult(t, s, u, 16), this.emitNumericEntity(r, 3);
    }
    return this.addToNumericResult(t, s, u, 16), -1;
  }
  stateNumericDecimal(t, u) {
    const s = u;
    for (; u < t.length; ) {
      const r = t.charCodeAt(u);
      if (Qe(r))
        u += 1;
      else
        return this.addToNumericResult(t, s, u, 10), this.emitNumericEntity(r, 2);
    }
    return this.addToNumericResult(t, s, u, 10), -1;
  }
  emitNumericEntity(t, u) {
    var s;
    if (this.consumed <= u)
      return (s = this.errors) === null || s === void 0 || s.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === g.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === X.Strict)
      return 0;
    return this.emitCodePoint(Dn(this.result), this.consumed), this.errors && (t !== g.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  stateNamedEntity(t, u) {
    const { decodeTree: s } = this;
    let r = s[this.treeIndex], o = (r & w.VALUE_LENGTH) >> 14;
    for (; u < t.length; u++, this.excess++) {
      const E = t.charCodeAt(u);
      if (this.treeIndex = $t(s, r, this.treeIndex + Math.max(1, o), E), this.treeIndex < 0)
        return this.result === 0 || this.decodeMode === X.Attribute && (o === 0 || Bn(E)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (r = s[this.treeIndex], o = (r & w.VALUE_LENGTH) >> 14, o !== 0) {
        if (E === g.SEMI)
          return this.emitNamedEntityData(this.treeIndex, o, this.consumed + this.excess);
        this.decodeMode !== X.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: u, decodeTree: s } = this, r = (s[u] & w.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(u, r, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  emitNamedEntityData(t, u, s) {
    const { decodeTree: r } = this;
    return this.emitCodePoint(u === 1 ? r[t] & ~w.VALUE_LENGTH : r[t + 1], s), u === 3 && this.emitCodePoint(r[t + 2], s), s;
  }
  end() {
    var t;
    switch (this.state) {
      case S.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== X.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case S.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case S.NumericHex:
        return this.emitNumericEntity(0, 3);
      case S.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case S.EntityStart:
        return 0;
    }
  }
}
function Dt(e) {
  let t = "";
  const u = new In(e, (s) => t += Cn(s));
  return function(s, r) {
    let o = 0, E = 0;
    for (; (E = s.indexOf("&", E)) >= 0; ) {
      t += s.slice(o, E), u.startEntity(r);
      const p = u.write(s, E + 1);
      if (p < 0) {
        o = E + u.end();
        break;
      }
      o = E + p, E = p === 0 ? o + 1 : o;
    }
    const T = t + s.slice(o);
    return t = "", T;
  };
}
function $t(e, t, u, s) {
  const r = (t & w.BRANCH_LENGTH) >> 7, o = t & w.JUMP_TABLE;
  if (r === 0)
    return o !== 0 && s === o ? u : -1;
  if (o) {
    const p = s - o;
    return p < 0 || p >= r ? -1 : e[u + p] - 1;
  }
  let E = u, T = E + r - 1;
  for (; E <= T; ) {
    const p = E + T >>> 1, D = e[p];
    if (D < s)
      E = p + 1;
    else if (D > s)
      T = p - 1;
    else
      return e[p + r];
  }
  return -1;
}
Dt(v), Dt(pn);
var h;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(h = h || (h = {}));
var W;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(W = W || (W = {}));
var P;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(P = P || (P = {}));
var l;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(l = l || (l = {}));
var n;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SECTION = 94] = "SECTION", e[e.SELECT = 95] = "SELECT", e[e.SOURCE = 96] = "SOURCE", e[e.SMALL = 97] = "SMALL", e[e.SPAN = 98] = "SPAN", e[e.STRIKE = 99] = "STRIKE", e[e.STRONG = 100] = "STRONG", e[e.STYLE = 101] = "STYLE", e[e.SUB = 102] = "SUB", e[e.SUMMARY = 103] = "SUMMARY", e[e.SUP = 104] = "SUP", e[e.TABLE = 105] = "TABLE", e[e.TBODY = 106] = "TBODY", e[e.TEMPLATE = 107] = "TEMPLATE", e[e.TEXTAREA = 108] = "TEXTAREA", e[e.TFOOT = 109] = "TFOOT", e[e.TD = 110] = "TD", e[e.TH = 111] = "TH", e[e.THEAD = 112] = "THEAD", e[e.TITLE = 113] = "TITLE", e[e.TR = 114] = "TR", e[e.TRACK = 115] = "TRACK", e[e.TT = 116] = "TT", e[e.U = 117] = "U", e[e.UL = 118] = "UL", e[e.SVG = 119] = "SVG", e[e.VAR = 120] = "VAR", e[e.WBR = 121] = "WBR", e[e.XMP = 122] = "XMP";
})(n = n || (n = {}));
const Nn = /* @__PURE__ */ new Map([[l.A, n.A], [l.ADDRESS, n.ADDRESS], [l.ANNOTATION_XML, n.ANNOTATION_XML], [l.APPLET, n.APPLET], [l.AREA, n.AREA], [l.ARTICLE, n.ARTICLE], [l.ASIDE, n.ASIDE], [l.B, n.B], [l.BASE, n.BASE], [l.BASEFONT, n.BASEFONT], [l.BGSOUND, n.BGSOUND], [l.BIG, n.BIG], [l.BLOCKQUOTE, n.BLOCKQUOTE], [l.BODY, n.BODY], [l.BR, n.BR], [l.BUTTON, n.BUTTON], [l.CAPTION, n.CAPTION], [l.CENTER, n.CENTER], [l.CODE, n.CODE], [l.COL, n.COL], [l.COLGROUP, n.COLGROUP], [l.DD, n.DD], [l.DESC, n.DESC], [l.DETAILS, n.DETAILS], [l.DIALOG, n.DIALOG], [l.DIR, n.DIR], [l.DIV, n.DIV], [l.DL, n.DL], [l.DT, n.DT], [l.EM, n.EM], [l.EMBED, n.EMBED], [l.FIELDSET, n.FIELDSET], [l.FIGCAPTION, n.FIGCAPTION], [l.FIGURE, n.FIGURE], [l.FONT, n.FONT], [l.FOOTER, n.FOOTER], [l.FOREIGN_OBJECT, n.FOREIGN_OBJECT], [l.FORM, n.FORM], [l.FRAME, n.FRAME], [l.FRAMESET, n.FRAMESET], [l.H1, n.H1], [l.H2, n.H2], [l.H3, n.H3], [l.H4, n.H4], [l.H5, n.H5], [l.H6, n.H6], [l.HEAD, n.HEAD], [l.HEADER, n.HEADER], [l.HGROUP, n.HGROUP], [l.HR, n.HR], [l.HTML, n.HTML], [l.I, n.I], [l.IMG, n.IMG], [l.IMAGE, n.IMAGE], [l.INPUT, n.INPUT], [l.IFRAME, n.IFRAME], [l.KEYGEN, n.KEYGEN], [l.LABEL, n.LABEL], [l.LI, n.LI], [l.LINK, n.LINK], [l.LISTING, n.LISTING], [l.MAIN, n.MAIN], [l.MALIGNMARK, n.MALIGNMARK], [l.MARQUEE, n.MARQUEE], [l.MATH, n.MATH], [l.MENU, n.MENU], [l.META, n.META], [l.MGLYPH, n.MGLYPH], [l.MI, n.MI], [l.MO, n.MO], [l.MN, n.MN], [l.MS, n.MS], [l.MTEXT, n.MTEXT], [l.NAV, n.NAV], [l.NOBR, n.NOBR], [l.NOFRAMES, n.NOFRAMES], [l.NOEMBED, n.NOEMBED], [l.NOSCRIPT, n.NOSCRIPT], [l.OBJECT, n.OBJECT], [l.OL, n.OL], [l.OPTGROUP, n.OPTGROUP], [l.OPTION, n.OPTION], [l.P, n.P], [l.PARAM, n.PARAM], [l.PLAINTEXT, n.PLAINTEXT], [l.PRE, n.PRE], [l.RB, n.RB], [l.RP, n.RP], [l.RT, n.RT], [l.RTC, n.RTC], [l.RUBY, n.RUBY], [l.S, n.S], [l.SCRIPT, n.SCRIPT], [l.SECTION, n.SECTION], [l.SELECT, n.SELECT], [l.SOURCE, n.SOURCE], [l.SMALL, n.SMALL], [l.SPAN, n.SPAN], [l.STRIKE, n.STRIKE], [l.STRONG, n.STRONG], [l.STYLE, n.STYLE], [l.SUB, n.SUB], [l.SUMMARY, n.SUMMARY], [l.SUP, n.SUP], [l.TABLE, n.TABLE], [l.TBODY, n.TBODY], [l.TEMPLATE, n.TEMPLATE], [l.TEXTAREA, n.TEXTAREA], [l.TFOOT, n.TFOOT], [l.TD, n.TD], [l.TH, n.TH], [l.THEAD, n.THEAD], [l.TITLE, n.TITLE], [l.TR, n.TR], [l.TRACK, n.TRACK], [l.TT, n.TT], [l.U, n.U], [l.UL, n.UL], [l.SVG, n.SVG], [l.VAR, n.VAR], [l.WBR, n.WBR], [l.XMP, n.XMP]]);
function Re(e) {
  var t;
  return (t = Nn.get(e)) !== null && t !== void 0 ? t : n.UNKNOWN;
}
const d = n, Sn = { [h.HTML]: /* @__PURE__ */ new Set([d.ADDRESS, d.APPLET, d.AREA, d.ARTICLE, d.ASIDE, d.BASE, d.BASEFONT, d.BGSOUND, d.BLOCKQUOTE, d.BODY, d.BR, d.BUTTON, d.CAPTION, d.CENTER, d.COL, d.COLGROUP, d.DD, d.DETAILS, d.DIR, d.DIV, d.DL, d.DT, d.EMBED, d.FIELDSET, d.FIGCAPTION, d.FIGURE, d.FOOTER, d.FORM, d.FRAME, d.FRAMESET, d.H1, d.H2, d.H3, d.H4, d.H5, d.H6, d.HEAD, d.HEADER, d.HGROUP, d.HR, d.HTML, d.IFRAME, d.IMG, d.INPUT, d.LI, d.LINK, d.LISTING, d.MAIN, d.MARQUEE, d.MENU, d.META, d.NAV, d.NOEMBED, d.NOFRAMES, d.NOSCRIPT, d.OBJECT, d.OL, d.P, d.PARAM, d.PLAINTEXT, d.PRE, d.SCRIPT, d.SECTION, d.SELECT, d.SOURCE, d.STYLE, d.SUMMARY, d.TABLE, d.TBODY, d.TD, d.TEMPLATE, d.TEXTAREA, d.TFOOT, d.TH, d.THEAD, d.TITLE, d.TR, d.TRACK, d.UL, d.WBR, d.XMP]), [h.MATHML]: /* @__PURE__ */ new Set([d.MI, d.MO, d.MN, d.MS, d.MTEXT, d.ANNOTATION_XML]), [h.SVG]: /* @__PURE__ */ new Set([d.TITLE, d.FOREIGN_OBJECT, d.DESC]), [h.XLINK]: /* @__PURE__ */ new Set(), [h.XML]: /* @__PURE__ */ new Set(), [h.XMLNS]: /* @__PURE__ */ new Set() };
function eu(e) {
  return e === d.H1 || e === d.H2 || e === d.H3 || e === d.H4 || e === d.H5 || e === d.H6;
}
l.STYLE, l.SCRIPT, l.XMP, l.IFRAME, l.NOEMBED, l.NOFRAMES, l.PLAINTEXT;
const gn = /* @__PURE__ */ new Map([[128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
var i;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.NAMED_CHARACTER_REFERENCE = 72] = "NAMED_CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 73] = "AMBIGUOUS_AMPERSAND", e[e.NUMERIC_CHARACTER_REFERENCE = 74] = "NUMERIC_CHARACTER_REFERENCE", e[e.HEXADEMICAL_CHARACTER_REFERENCE_START = 75] = "HEXADEMICAL_CHARACTER_REFERENCE_START", e[e.HEXADEMICAL_CHARACTER_REFERENCE = 76] = "HEXADEMICAL_CHARACTER_REFERENCE", e[e.DECIMAL_CHARACTER_REFERENCE = 77] = "DECIMAL_CHARACTER_REFERENCE", e[e.NUMERIC_CHARACTER_REFERENCE_END = 78] = "NUMERIC_CHARACTER_REFERENCE_END";
})(i || (i = {}));
const k = { DATA: i.DATA, RCDATA: i.RCDATA, RAWTEXT: i.RAWTEXT, SCRIPT_DATA: i.SCRIPT_DATA, PLAINTEXT: i.PLAINTEXT, CDATA_SECTION: i.CDATA_SECTION };
function oe(e) {
  return e >= a.DIGIT_0 && e <= a.DIGIT_9;
}
function re(e) {
  return e >= a.LATIN_CAPITAL_A && e <= a.LATIN_CAPITAL_Z;
}
function Fn(e) {
  return e >= a.LATIN_SMALL_A && e <= a.LATIN_SMALL_Z;
}
function Y(e) {
  return Fn(e) || re(e);
}
function Xe(e) {
  return Y(e) || oe(e);
}
function tu(e) {
  return e >= a.LATIN_CAPITAL_A && e <= a.LATIN_CAPITAL_F;
}
function uu(e) {
  return e >= a.LATIN_SMALL_A && e <= a.LATIN_SMALL_F;
}
function Rn(e) {
  return oe(e) || tu(e) || uu(e);
}
function me(e) {
  return e + 32;
}
function nu(e) {
  return e === a.SPACE || e === a.LINE_FEED || e === a.TABULATION || e === a.FORM_FEED;
}
function On(e) {
  return e === a.EQUALS_SIGN || Xe(e);
}
function mt(e) {
  return nu(e) || e === a.SOLIDUS || e === a.GREATER_THAN_SIGN;
}
class Ln {
  constructor(t, u) {
    this.options = t, this.handler = u, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = i.DATA, this.returnState = i.DATA, this.charRefCode = -1, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new Tn(u), this.currentLocation = this.getCurrentLocation(-1);
  }
  _err(t) {
    var u, s;
    (s = (u = this.handler).onParseError) === null || s === void 0 || s.call(u, this.preprocessor.getError(t));
  }
  getCurrentLocation(t) {
    return this.options.sourceCodeLocationInfo ? { startLine: this.preprocessor.line, startCol: this.preprocessor.col - t, startOffset: this.preprocessor.offset - t, endLine: -1, endCol: -1, endOffset: -1 } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const t = this._consume();
        this._ensureHibernation() || this._callState(t);
      }
      this.inLoop = !1;
    }
  }
  pause() {
    this.paused = !0;
  }
  resume(t) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || (t == null || t()));
  }
  write(t, u, s) {
    this.active = !0, this.preprocessor.write(t, u), this._runParsingLoop(), this.paused || (s == null || s());
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t), this._runParsingLoop();
  }
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this._unconsume(this.consumedAfterSnapshot), this.active = !1, !0) : !1;
  }
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _unconsume(t) {
    this.consumedAfterSnapshot -= t, this.preprocessor.retreat(t);
  }
  _reconsumeInState(t, u) {
    this.state = t, this._callState(u);
  }
  _advanceBy(t) {
    this.consumedAfterSnapshot += t;
    for (let u = 0; u < t; u++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(t, u) {
    return this.preprocessor.startsWith(t, u) ? (this._advanceBy(t.length - 1), !0) : !1;
  }
  _createStartTagToken() {
    this.currentToken = { type: f.START_TAG, tagName: "", tagID: n.UNKNOWN, selfClosing: !1, ackSelfClosing: !1, attrs: [], location: this.getCurrentLocation(1) };
  }
  _createEndTagToken() {
    this.currentToken = { type: f.END_TAG, tagName: "", tagID: n.UNKNOWN, selfClosing: !1, ackSelfClosing: !1, attrs: [], location: this.getCurrentLocation(2) };
  }
  _createCommentToken(t) {
    this.currentToken = { type: f.COMMENT, data: "", location: this.getCurrentLocation(t) };
  }
  _createDoctypeToken(t) {
    this.currentToken = { type: f.DOCTYPE, name: t, forceQuirks: !1, publicId: null, systemId: null, location: this.currentLocation };
  }
  _createCharacterToken(t, u) {
    this.currentCharacterToken = { type: t, chars: u, location: this.currentLocation };
  }
  _createAttr(t) {
    this.currentAttr = { name: t, value: "" }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var t, u;
    const s = this.currentToken;
    if (Zt(s, this.currentAttr.name) === null) {
      if (s.attrs.push(this.currentAttr), s.location && this.currentLocation) {
        const r = (t = (u = s.location).attrs) !== null && t !== void 0 ? t : u.attrs = /* @__PURE__ */ Object.create(null);
        r[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(A.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  prepareToken(t) {
    this._emitCurrentCharacterToken(t.location), this.currentToken = null, t.location && (t.location.endLine = this.preprocessor.line, t.location.endCol = this.preprocessor.col + 1, t.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const t = this.currentToken;
    this.prepareToken(t), t.tagID = Re(t.tagName), t.type === f.START_TAG ? (this.lastStartTagName = t.tagName, this.handler.onStartTag(t)) : (t.attrs.length > 0 && this._err(A.endTagWithAttributes), t.selfClosing && this._err(A.endTagWithTrailingSolidus), this.handler.onEndTag(t)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(t) {
    this.prepareToken(t), this.handler.onComment(t), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(t) {
    this.prepareToken(t), this.handler.onDoctype(t), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(t) {
    if (this.currentCharacterToken) {
      switch (t && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = t.startLine, this.currentCharacterToken.location.endCol = t.startCol, this.currentCharacterToken.location.endOffset = t.startOffset), this.currentCharacterToken.type) {
        case f.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case f.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case f.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const t = this.getCurrentLocation(0);
    t && (t.endLine = t.startLine, t.endCol = t.startCol, t.endOffset = t.startOffset), this._emitCurrentCharacterToken(t), this.handler.onEof({ type: f.EOF, location: t }), this.active = !1;
  }
  _appendCharToCurrentCharacterToken(t, u) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type !== t)
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
      else {
        this.currentCharacterToken.chars += u;
        return;
      }
    this._createCharacterToken(t, u);
  }
  _emitCodePoint(t) {
    const u = nu(t) ? f.WHITESPACE_CHARACTER : t === a.NULL ? f.NULL_CHARACTER : f.CHARACTER;
    this._appendCharToCurrentCharacterToken(u, String.fromCodePoint(t));
  }
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(f.CHARACTER, t);
  }
  _matchNamedCharacterReference(t) {
    let u = null, s = 0, r = !1;
    for (let o = 0, E = v[0]; o >= 0 && (o = $t(v, E, o + 1, t), !(o < 0)); t = this._consume()) {
      s += 1, E = v[o];
      const T = E & w.VALUE_LENGTH;
      if (T) {
        const p = (T >> 14) - 1;
        if (t !== a.SEMICOLON && this._isCharacterReferenceInAttribute() && On(this.preprocessor.peek(1)) ? (u = [a.AMPERSAND], o += p) : (u = p === 0 ? [v[o] & ~w.VALUE_LENGTH] : p === 1 ? [v[++o]] : [v[++o], v[++o]], s = 0, r = t !== a.SEMICOLON), p === 0) {
          this._consume();
          break;
        }
      }
    }
    return this._unconsume(s), r && !this.preprocessor.endOfChunkHit && this._err(A.missingSemicolonAfterCharacterReference), this._unconsume(1), u;
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === i.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === i.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === i.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(t) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(t) : this._emitCodePoint(t);
  }
  _callState(t) {
    switch (this.state) {
      case i.DATA: {
        this._stateData(t);
        break;
      }
      case i.RCDATA: {
        this._stateRcdata(t);
        break;
      }
      case i.RAWTEXT: {
        this._stateRawtext(t);
        break;
      }
      case i.SCRIPT_DATA: {
        this._stateScriptData(t);
        break;
      }
      case i.PLAINTEXT: {
        this._statePlaintext(t);
        break;
      }
      case i.TAG_OPEN: {
        this._stateTagOpen(t);
        break;
      }
      case i.END_TAG_OPEN: {
        this._stateEndTagOpen(t);
        break;
      }
      case i.TAG_NAME: {
        this._stateTagName(t);
        break;
      }
      case i.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(t);
        break;
      }
      case i.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(t);
        break;
      }
      case i.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(t);
        break;
      }
      case i.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(t);
        break;
      }
      case i.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(t);
        break;
      }
      case i.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(t);
        break;
      }
      case i.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(t);
        break;
      }
      case i.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(t);
        break;
      }
      case i.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(t);
        break;
      }
      case i.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(t);
        break;
      }
      case i.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(t);
        break;
      }
      case i.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(t);
        break;
      }
      case i.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(t);
        break;
      }
      case i.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(t);
        break;
      }
      case i.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(t);
        break;
      }
      case i.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(t);
        break;
      }
      case i.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(t);
        break;
      }
      case i.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(t);
        break;
      }
      case i.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(t);
        break;
      }
      case i.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(t);
        break;
      }
      case i.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(t);
        break;
      }
      case i.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(t);
        break;
      }
      case i.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(t);
        break;
      }
      case i.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(t);
        break;
      }
      case i.ATTRIBUTE_NAME: {
        this._stateAttributeName(t);
        break;
      }
      case i.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(t);
        break;
      }
      case i.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(t);
        break;
      }
      case i.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(t);
        break;
      }
      case i.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(t);
        break;
      }
      case i.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(t);
        break;
      }
      case i.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(t);
        break;
      }
      case i.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(t);
        break;
      }
      case i.BOGUS_COMMENT: {
        this._stateBogusComment(t);
        break;
      }
      case i.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(t);
        break;
      }
      case i.COMMENT_START: {
        this._stateCommentStart(t);
        break;
      }
      case i.COMMENT_START_DASH: {
        this._stateCommentStartDash(t);
        break;
      }
      case i.COMMENT: {
        this._stateComment(t);
        break;
      }
      case i.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(t);
        break;
      }
      case i.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(t);
        break;
      }
      case i.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(t);
        break;
      }
      case i.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(t);
        break;
      }
      case i.COMMENT_END_DASH: {
        this._stateCommentEndDash(t);
        break;
      }
      case i.COMMENT_END: {
        this._stateCommentEnd(t);
        break;
      }
      case i.COMMENT_END_BANG: {
        this._stateCommentEndBang(t);
        break;
      }
      case i.DOCTYPE: {
        this._stateDoctype(t);
        break;
      }
      case i.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(t);
        break;
      }
      case i.DOCTYPE_NAME: {
        this._stateDoctypeName(t);
        break;
      }
      case i.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(t);
        break;
      }
      case i.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(t);
        break;
      }
      case i.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(t);
        break;
      }
      case i.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(t);
        break;
      }
      case i.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(t);
        break;
      }
      case i.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(t);
        break;
      }
      case i.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(t);
        break;
      }
      case i.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(t);
        break;
      }
      case i.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(t);
        break;
      }
      case i.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(t);
        break;
      }
      case i.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(t);
        break;
      }
      case i.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(t);
        break;
      }
      case i.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(t);
        break;
      }
      case i.CDATA_SECTION: {
        this._stateCdataSection(t);
        break;
      }
      case i.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(t);
        break;
      }
      case i.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(t);
        break;
      }
      case i.CHARACTER_REFERENCE: {
        this._stateCharacterReference(t);
        break;
      }
      case i.NAMED_CHARACTER_REFERENCE: {
        this._stateNamedCharacterReference(t);
        break;
      }
      case i.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(t);
        break;
      }
      case i.NUMERIC_CHARACTER_REFERENCE: {
        this._stateNumericCharacterReference(t);
        break;
      }
      case i.HEXADEMICAL_CHARACTER_REFERENCE_START: {
        this._stateHexademicalCharacterReferenceStart(t);
        break;
      }
      case i.HEXADEMICAL_CHARACTER_REFERENCE: {
        this._stateHexademicalCharacterReference(t);
        break;
      }
      case i.DECIMAL_CHARACTER_REFERENCE: {
        this._stateDecimalCharacterReference(t);
        break;
      }
      case i.NUMERIC_CHARACTER_REFERENCE_END: {
        this._stateNumericCharacterReferenceEnd(t);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  _stateData(t) {
    switch (t) {
      case a.LESS_THAN_SIGN: {
        this.state = i.TAG_OPEN;
        break;
      }
      case a.AMPERSAND: {
        this.returnState = i.DATA, this.state = i.CHARACTER_REFERENCE;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this._emitCodePoint(t);
        break;
      }
      case a.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateRcdata(t) {
    switch (t) {
      case a.AMPERSAND: {
        this.returnState = i.RCDATA, this.state = i.CHARACTER_REFERENCE;
        break;
      }
      case a.LESS_THAN_SIGN: {
        this.state = i.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this._emitChars(I);
        break;
      }
      case a.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateRawtext(t) {
    switch (t) {
      case a.LESS_THAN_SIGN: {
        this.state = i.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this._emitChars(I);
        break;
      }
      case a.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateScriptData(t) {
    switch (t) {
      case a.LESS_THAN_SIGN: {
        this.state = i.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this._emitChars(I);
        break;
      }
      case a.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  _statePlaintext(t) {
    switch (t) {
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this._emitChars(I);
        break;
      }
      case a.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateTagOpen(t) {
    if (Y(t))
      this._createStartTagToken(), this.state = i.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case a.EXCLAMATION_MARK: {
          this.state = i.MARKUP_DECLARATION_OPEN;
          break;
        }
        case a.SOLIDUS: {
          this.state = i.END_TAG_OPEN;
          break;
        }
        case a.QUESTION_MARK: {
          this._err(A.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = i.BOGUS_COMMENT, this._stateBogusComment(t);
          break;
        }
        case a.EOF: {
          this._err(A.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(A.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = i.DATA, this._stateData(t);
      }
  }
  _stateEndTagOpen(t) {
    if (Y(t))
      this._createEndTagToken(), this.state = i.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case a.GREATER_THAN_SIGN: {
          this._err(A.missingEndTagName), this.state = i.DATA;
          break;
        }
        case a.EOF: {
          this._err(A.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(A.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = i.BOGUS_COMMENT, this._stateBogusComment(t);
      }
  }
  _stateTagName(t) {
    const u = this.currentToken;
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED: {
        this.state = i.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case a.SOLIDUS: {
        this.state = i.SELF_CLOSING_START_TAG;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this.state = i.DATA, this.emitCurrentTagToken();
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), u.tagName += I;
        break;
      }
      case a.EOF: {
        this._err(A.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        u.tagName += String.fromCodePoint(re(t) ? me(t) : t);
    }
  }
  _stateRcdataLessThanSign(t) {
    t === a.SOLIDUS ? this.state = i.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = i.RCDATA, this._stateRcdata(t));
  }
  _stateRcdataEndTagOpen(t) {
    Y(t) ? (this.state = i.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(t)) : (this._emitChars("</"), this.state = i.RCDATA, this._stateRcdata(t));
  }
  handleSpecialEndTag(t) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const u = this.currentToken;
    switch (u.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = i.BEFORE_ATTRIBUTE_NAME, !1;
      case a.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = i.SELF_CLOSING_START_TAG, !1;
      case a.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = i.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  _stateRcdataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = i.RCDATA, this._stateRcdata(t));
  }
  _stateRawtextLessThanSign(t) {
    t === a.SOLIDUS ? this.state = i.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = i.RAWTEXT, this._stateRawtext(t));
  }
  _stateRawtextEndTagOpen(t) {
    Y(t) ? (this.state = i.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(t)) : (this._emitChars("</"), this.state = i.RAWTEXT, this._stateRawtext(t));
  }
  _stateRawtextEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = i.RAWTEXT, this._stateRawtext(t));
  }
  _stateScriptDataLessThanSign(t) {
    switch (t) {
      case a.SOLIDUS: {
        this.state = i.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case a.EXCLAMATION_MARK: {
        this.state = i.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = i.SCRIPT_DATA, this._stateScriptData(t);
    }
  }
  _stateScriptDataEndTagOpen(t) {
    Y(t) ? (this.state = i.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(t)) : (this._emitChars("</"), this.state = i.SCRIPT_DATA, this._stateScriptData(t));
  }
  _stateScriptDataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = i.SCRIPT_DATA, this._stateScriptData(t));
  }
  _stateScriptDataEscapeStart(t) {
    t === a.HYPHEN_MINUS ? (this.state = i.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = i.SCRIPT_DATA, this._stateScriptData(t));
  }
  _stateScriptDataEscapeStartDash(t) {
    t === a.HYPHEN_MINUS ? (this.state = i.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = i.SCRIPT_DATA, this._stateScriptData(t));
  }
  _stateScriptDataEscaped(t) {
    switch (t) {
      case a.HYPHEN_MINUS: {
        this.state = i.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case a.LESS_THAN_SIGN: {
        this.state = i.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this._emitChars(I);
        break;
      }
      case a.EOF: {
        this._err(A.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateScriptDataEscapedDash(t) {
    switch (t) {
      case a.HYPHEN_MINUS: {
        this.state = i.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case a.LESS_THAN_SIGN: {
        this.state = i.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this.state = i.SCRIPT_DATA_ESCAPED, this._emitChars(I);
        break;
      }
      case a.EOF: {
        this._err(A.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = i.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  _stateScriptDataEscapedDashDash(t) {
    switch (t) {
      case a.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case a.LESS_THAN_SIGN: {
        this.state = i.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this.state = i.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this.state = i.SCRIPT_DATA_ESCAPED, this._emitChars(I);
        break;
      }
      case a.EOF: {
        this._err(A.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = i.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  _stateScriptDataEscapedLessThanSign(t) {
    t === a.SOLIDUS ? this.state = i.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : Y(t) ? (this._emitChars("<"), this.state = i.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(t)) : (this._emitChars("<"), this.state = i.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  _stateScriptDataEscapedEndTagOpen(t) {
    Y(t) ? (this.state = i.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(t)) : (this._emitChars("</"), this.state = i.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  _stateScriptDataEscapedEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = i.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  _stateScriptDataDoubleEscapeStart(t) {
    if (this.preprocessor.startsWith(L.SCRIPT, !1) && mt(this.preprocessor.peek(L.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let u = 0; u < L.SCRIPT.length; u++)
        this._emitCodePoint(this._consume());
      this.state = i.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else
      this._ensureHibernation() || (this.state = i.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  _stateScriptDataDoubleEscaped(t) {
    switch (t) {
      case a.HYPHEN_MINUS: {
        this.state = i.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case a.LESS_THAN_SIGN: {
        this.state = i.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this._emitChars(I);
        break;
      }
      case a.EOF: {
        this._err(A.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateScriptDataDoubleEscapedDash(t) {
    switch (t) {
      case a.HYPHEN_MINUS: {
        this.state = i.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case a.LESS_THAN_SIGN: {
        this.state = i.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this.state = i.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(I);
        break;
      }
      case a.EOF: {
        this._err(A.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = i.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  _stateScriptDataDoubleEscapedDashDash(t) {
    switch (t) {
      case a.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case a.LESS_THAN_SIGN: {
        this.state = i.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this.state = i.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this.state = i.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(I);
        break;
      }
      case a.EOF: {
        this._err(A.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = i.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  _stateScriptDataDoubleEscapedLessThanSign(t) {
    t === a.SOLIDUS ? (this.state = i.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = i.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  _stateScriptDataDoubleEscapeEnd(t) {
    if (this.preprocessor.startsWith(L.SCRIPT, !1) && mt(this.preprocessor.peek(L.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let u = 0; u < L.SCRIPT.length; u++)
        this._emitCodePoint(this._consume());
      this.state = i.SCRIPT_DATA_ESCAPED;
    } else
      this._ensureHibernation() || (this.state = i.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  _stateBeforeAttributeName(t) {
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED:
        break;
      case a.SOLIDUS:
      case a.GREATER_THAN_SIGN:
      case a.EOF: {
        this.state = i.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case a.EQUALS_SIGN: {
        this._err(A.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = i.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = i.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  _stateAttributeName(t) {
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED:
      case a.SOLIDUS:
      case a.GREATER_THAN_SIGN:
      case a.EOF: {
        this._leaveAttrName(), this.state = i.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case a.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = i.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case a.QUOTATION_MARK:
      case a.APOSTROPHE:
      case a.LESS_THAN_SIGN: {
        this._err(A.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(t);
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this.currentAttr.name += I;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(re(t) ? me(t) : t);
    }
  }
  _stateAfterAttributeName(t) {
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED:
        break;
      case a.SOLIDUS: {
        this.state = i.SELF_CLOSING_START_TAG;
        break;
      }
      case a.EQUALS_SIGN: {
        this.state = i.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this.state = i.DATA, this.emitCurrentTagToken();
        break;
      }
      case a.EOF: {
        this._err(A.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = i.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  _stateBeforeAttributeValue(t) {
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED:
        break;
      case a.QUOTATION_MARK: {
        this.state = i.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case a.APOSTROPHE: {
        this.state = i.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._err(A.missingAttributeValue), this.state = i.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = i.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(t);
    }
  }
  _stateAttributeValueDoubleQuoted(t) {
    switch (t) {
      case a.QUOTATION_MARK: {
        this.state = i.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case a.AMPERSAND: {
        this.returnState = i.ATTRIBUTE_VALUE_DOUBLE_QUOTED, this.state = i.CHARACTER_REFERENCE;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this.currentAttr.value += I;
        break;
      }
      case a.EOF: {
        this._err(A.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  _stateAttributeValueSingleQuoted(t) {
    switch (t) {
      case a.APOSTROPHE: {
        this.state = i.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case a.AMPERSAND: {
        this.returnState = i.ATTRIBUTE_VALUE_SINGLE_QUOTED, this.state = i.CHARACTER_REFERENCE;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this.currentAttr.value += I;
        break;
      }
      case a.EOF: {
        this._err(A.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  _stateAttributeValueUnquoted(t) {
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED: {
        this._leaveAttrValue(), this.state = i.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case a.AMPERSAND: {
        this.returnState = i.ATTRIBUTE_VALUE_UNQUOTED, this.state = i.CHARACTER_REFERENCE;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = i.DATA, this.emitCurrentTagToken();
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), this.currentAttr.value += I;
        break;
      }
      case a.QUOTATION_MARK:
      case a.APOSTROPHE:
      case a.LESS_THAN_SIGN:
      case a.EQUALS_SIGN:
      case a.GRAVE_ACCENT: {
        this._err(A.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(t);
        break;
      }
      case a.EOF: {
        this._err(A.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  _stateAfterAttributeValueQuoted(t) {
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED: {
        this._leaveAttrValue(), this.state = i.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case a.SOLIDUS: {
        this._leaveAttrValue(), this.state = i.SELF_CLOSING_START_TAG;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = i.DATA, this.emitCurrentTagToken();
        break;
      }
      case a.EOF: {
        this._err(A.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(A.missingWhitespaceBetweenAttributes), this.state = i.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  _stateSelfClosingStartTag(t) {
    switch (t) {
      case a.GREATER_THAN_SIGN: {
        const u = this.currentToken;
        u.selfClosing = !0, this.state = i.DATA, this.emitCurrentTagToken();
        break;
      }
      case a.EOF: {
        this._err(A.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(A.unexpectedSolidusInTag), this.state = i.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  _stateBogusComment(t) {
    const u = this.currentToken;
    switch (t) {
      case a.GREATER_THAN_SIGN: {
        this.state = i.DATA, this.emitCurrentComment(u);
        break;
      }
      case a.EOF: {
        this.emitCurrentComment(u), this._emitEOFToken();
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), u.data += I;
        break;
      }
      default:
        u.data += String.fromCodePoint(t);
    }
  }
  _stateMarkupDeclarationOpen(t) {
    this._consumeSequenceIfMatch(L.DASH_DASH, !0) ? (this._createCommentToken(L.DASH_DASH.length + 1), this.state = i.COMMENT_START) : this._consumeSequenceIfMatch(L.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(L.DOCTYPE.length + 1), this.state = i.DOCTYPE) : this._consumeSequenceIfMatch(L.CDATA_START, !0) ? this.inForeignNode ? this.state = i.CDATA_SECTION : (this._err(A.cdataInHtmlContent), this._createCommentToken(L.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = i.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(A.incorrectlyOpenedComment), this._createCommentToken(2), this.state = i.BOGUS_COMMENT, this._stateBogusComment(t));
  }
  _stateCommentStart(t) {
    switch (t) {
      case a.HYPHEN_MINUS: {
        this.state = i.COMMENT_START_DASH;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._err(A.abruptClosingOfEmptyComment), this.state = i.DATA;
        const u = this.currentToken;
        this.emitCurrentComment(u);
        break;
      }
      default:
        this.state = i.COMMENT, this._stateComment(t);
    }
  }
  _stateCommentStartDash(t) {
    const u = this.currentToken;
    switch (t) {
      case a.HYPHEN_MINUS: {
        this.state = i.COMMENT_END;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._err(A.abruptClosingOfEmptyComment), this.state = i.DATA, this.emitCurrentComment(u);
        break;
      }
      case a.EOF: {
        this._err(A.eofInComment), this.emitCurrentComment(u), this._emitEOFToken();
        break;
      }
      default:
        u.data += "-", this.state = i.COMMENT, this._stateComment(t);
    }
  }
  _stateComment(t) {
    const u = this.currentToken;
    switch (t) {
      case a.HYPHEN_MINUS: {
        this.state = i.COMMENT_END_DASH;
        break;
      }
      case a.LESS_THAN_SIGN: {
        u.data += "<", this.state = i.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), u.data += I;
        break;
      }
      case a.EOF: {
        this._err(A.eofInComment), this.emitCurrentComment(u), this._emitEOFToken();
        break;
      }
      default:
        u.data += String.fromCodePoint(t);
    }
  }
  _stateCommentLessThanSign(t) {
    const u = this.currentToken;
    switch (t) {
      case a.EXCLAMATION_MARK: {
        u.data += "!", this.state = i.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case a.LESS_THAN_SIGN: {
        u.data += "<";
        break;
      }
      default:
        this.state = i.COMMENT, this._stateComment(t);
    }
  }
  _stateCommentLessThanSignBang(t) {
    t === a.HYPHEN_MINUS ? this.state = i.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = i.COMMENT, this._stateComment(t));
  }
  _stateCommentLessThanSignBangDash(t) {
    t === a.HYPHEN_MINUS ? this.state = i.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = i.COMMENT_END_DASH, this._stateCommentEndDash(t));
  }
  _stateCommentLessThanSignBangDashDash(t) {
    t !== a.GREATER_THAN_SIGN && t !== a.EOF && this._err(A.nestedComment), this.state = i.COMMENT_END, this._stateCommentEnd(t);
  }
  _stateCommentEndDash(t) {
    const u = this.currentToken;
    switch (t) {
      case a.HYPHEN_MINUS: {
        this.state = i.COMMENT_END;
        break;
      }
      case a.EOF: {
        this._err(A.eofInComment), this.emitCurrentComment(u), this._emitEOFToken();
        break;
      }
      default:
        u.data += "-", this.state = i.COMMENT, this._stateComment(t);
    }
  }
  _stateCommentEnd(t) {
    const u = this.currentToken;
    switch (t) {
      case a.GREATER_THAN_SIGN: {
        this.state = i.DATA, this.emitCurrentComment(u);
        break;
      }
      case a.EXCLAMATION_MARK: {
        this.state = i.COMMENT_END_BANG;
        break;
      }
      case a.HYPHEN_MINUS: {
        u.data += "-";
        break;
      }
      case a.EOF: {
        this._err(A.eofInComment), this.emitCurrentComment(u), this._emitEOFToken();
        break;
      }
      default:
        u.data += "--", this.state = i.COMMENT, this._stateComment(t);
    }
  }
  _stateCommentEndBang(t) {
    const u = this.currentToken;
    switch (t) {
      case a.HYPHEN_MINUS: {
        u.data += "--!", this.state = i.COMMENT_END_DASH;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._err(A.incorrectlyClosedComment), this.state = i.DATA, this.emitCurrentComment(u);
        break;
      }
      case a.EOF: {
        this._err(A.eofInComment), this.emitCurrentComment(u), this._emitEOFToken();
        break;
      }
      default:
        u.data += "--!", this.state = i.COMMENT, this._stateComment(t);
    }
  }
  _stateDoctype(t) {
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED: {
        this.state = i.BEFORE_DOCTYPE_NAME;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this.state = i.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), this._createDoctypeToken(null);
        const u = this.currentToken;
        u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(A.missingWhitespaceBeforeDoctypeName), this.state = i.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
    }
  }
  _stateBeforeDoctypeName(t) {
    if (re(t))
      this._createDoctypeToken(String.fromCharCode(me(t))), this.state = i.DOCTYPE_NAME;
    else
      switch (t) {
        case a.SPACE:
        case a.LINE_FEED:
        case a.TABULATION:
        case a.FORM_FEED:
          break;
        case a.NULL: {
          this._err(A.unexpectedNullCharacter), this._createDoctypeToken(I), this.state = i.DOCTYPE_NAME;
          break;
        }
        case a.GREATER_THAN_SIGN: {
          this._err(A.missingDoctypeName), this._createDoctypeToken(null);
          const u = this.currentToken;
          u.forceQuirks = !0, this.emitCurrentDoctype(u), this.state = i.DATA;
          break;
        }
        case a.EOF: {
          this._err(A.eofInDoctype), this._createDoctypeToken(null);
          const u = this.currentToken;
          u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(t)), this.state = i.DOCTYPE_NAME;
      }
  }
  _stateDoctypeName(t) {
    const u = this.currentToken;
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED: {
        this.state = i.AFTER_DOCTYPE_NAME;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this.state = i.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), u.name += I;
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        u.name += String.fromCodePoint(re(t) ? me(t) : t);
    }
  }
  _stateAfterDoctypeName(t) {
    const u = this.currentToken;
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED:
        break;
      case a.GREATER_THAN_SIGN: {
        this.state = i.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(L.PUBLIC, !1) ? this.state = i.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(L.SYSTEM, !1) ? this.state = i.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(A.invalidCharacterSequenceAfterDoctypeName), u.forceQuirks = !0, this.state = i.BOGUS_DOCTYPE, this._stateBogusDoctype(t));
    }
  }
  _stateAfterDoctypePublicKeyword(t) {
    const u = this.currentToken;
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED: {
        this.state = i.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case a.QUOTATION_MARK: {
        this._err(A.missingWhitespaceAfterDoctypePublicKeyword), u.publicId = "", this.state = i.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case a.APOSTROPHE: {
        this._err(A.missingWhitespaceAfterDoctypePublicKeyword), u.publicId = "", this.state = i.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._err(A.missingDoctypePublicIdentifier), u.forceQuirks = !0, this.state = i.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(A.missingQuoteBeforeDoctypePublicIdentifier), u.forceQuirks = !0, this.state = i.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateBeforeDoctypePublicIdentifier(t) {
    const u = this.currentToken;
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED:
        break;
      case a.QUOTATION_MARK: {
        u.publicId = "", this.state = i.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case a.APOSTROPHE: {
        u.publicId = "", this.state = i.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._err(A.missingDoctypePublicIdentifier), u.forceQuirks = !0, this.state = i.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(A.missingQuoteBeforeDoctypePublicIdentifier), u.forceQuirks = !0, this.state = i.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateDoctypePublicIdentifierDoubleQuoted(t) {
    const u = this.currentToken;
    switch (t) {
      case a.QUOTATION_MARK: {
        this.state = i.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), u.publicId += I;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._err(A.abruptDoctypePublicIdentifier), u.forceQuirks = !0, this.emitCurrentDoctype(u), this.state = i.DATA;
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        u.publicId += String.fromCodePoint(t);
    }
  }
  _stateDoctypePublicIdentifierSingleQuoted(t) {
    const u = this.currentToken;
    switch (t) {
      case a.APOSTROPHE: {
        this.state = i.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), u.publicId += I;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._err(A.abruptDoctypePublicIdentifier), u.forceQuirks = !0, this.emitCurrentDoctype(u), this.state = i.DATA;
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        u.publicId += String.fromCodePoint(t);
    }
  }
  _stateAfterDoctypePublicIdentifier(t) {
    const u = this.currentToken;
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED: {
        this.state = i.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this.state = i.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case a.QUOTATION_MARK: {
        this._err(A.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), u.systemId = "", this.state = i.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case a.APOSTROPHE: {
        this._err(A.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), u.systemId = "", this.state = i.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(A.missingQuoteBeforeDoctypeSystemIdentifier), u.forceQuirks = !0, this.state = i.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateBetweenDoctypePublicAndSystemIdentifiers(t) {
    const u = this.currentToken;
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED:
        break;
      case a.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(u), this.state = i.DATA;
        break;
      }
      case a.QUOTATION_MARK: {
        u.systemId = "", this.state = i.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case a.APOSTROPHE: {
        u.systemId = "", this.state = i.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(A.missingQuoteBeforeDoctypeSystemIdentifier), u.forceQuirks = !0, this.state = i.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateAfterDoctypeSystemKeyword(t) {
    const u = this.currentToken;
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED: {
        this.state = i.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case a.QUOTATION_MARK: {
        this._err(A.missingWhitespaceAfterDoctypeSystemKeyword), u.systemId = "", this.state = i.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case a.APOSTROPHE: {
        this._err(A.missingWhitespaceAfterDoctypeSystemKeyword), u.systemId = "", this.state = i.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._err(A.missingDoctypeSystemIdentifier), u.forceQuirks = !0, this.state = i.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(A.missingQuoteBeforeDoctypeSystemIdentifier), u.forceQuirks = !0, this.state = i.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateBeforeDoctypeSystemIdentifier(t) {
    const u = this.currentToken;
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED:
        break;
      case a.QUOTATION_MARK: {
        u.systemId = "", this.state = i.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case a.APOSTROPHE: {
        u.systemId = "", this.state = i.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._err(A.missingDoctypeSystemIdentifier), u.forceQuirks = !0, this.state = i.DATA, this.emitCurrentDoctype(u);
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(A.missingQuoteBeforeDoctypeSystemIdentifier), u.forceQuirks = !0, this.state = i.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateDoctypeSystemIdentifierDoubleQuoted(t) {
    const u = this.currentToken;
    switch (t) {
      case a.QUOTATION_MARK: {
        this.state = i.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), u.systemId += I;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._err(A.abruptDoctypeSystemIdentifier), u.forceQuirks = !0, this.emitCurrentDoctype(u), this.state = i.DATA;
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        u.systemId += String.fromCodePoint(t);
    }
  }
  _stateDoctypeSystemIdentifierSingleQuoted(t) {
    const u = this.currentToken;
    switch (t) {
      case a.APOSTROPHE: {
        this.state = i.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter), u.systemId += I;
        break;
      }
      case a.GREATER_THAN_SIGN: {
        this._err(A.abruptDoctypeSystemIdentifier), u.forceQuirks = !0, this.emitCurrentDoctype(u), this.state = i.DATA;
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        u.systemId += String.fromCodePoint(t);
    }
  }
  _stateAfterDoctypeSystemIdentifier(t) {
    const u = this.currentToken;
    switch (t) {
      case a.SPACE:
      case a.LINE_FEED:
      case a.TABULATION:
      case a.FORM_FEED:
        break;
      case a.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(u), this.state = i.DATA;
        break;
      }
      case a.EOF: {
        this._err(A.eofInDoctype), u.forceQuirks = !0, this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
      default:
        this._err(A.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = i.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  _stateBogusDoctype(t) {
    const u = this.currentToken;
    switch (t) {
      case a.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(u), this.state = i.DATA;
        break;
      }
      case a.NULL: {
        this._err(A.unexpectedNullCharacter);
        break;
      }
      case a.EOF: {
        this.emitCurrentDoctype(u), this._emitEOFToken();
        break;
      }
    }
  }
  _stateCdataSection(t) {
    switch (t) {
      case a.RIGHT_SQUARE_BRACKET: {
        this.state = i.CDATA_SECTION_BRACKET;
        break;
      }
      case a.EOF: {
        this._err(A.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  _stateCdataSectionBracket(t) {
    t === a.RIGHT_SQUARE_BRACKET ? this.state = i.CDATA_SECTION_END : (this._emitChars("]"), this.state = i.CDATA_SECTION, this._stateCdataSection(t));
  }
  _stateCdataSectionEnd(t) {
    switch (t) {
      case a.GREATER_THAN_SIGN: {
        this.state = i.DATA;
        break;
      }
      case a.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = i.CDATA_SECTION, this._stateCdataSection(t);
    }
  }
  _stateCharacterReference(t) {
    t === a.NUMBER_SIGN ? this.state = i.NUMERIC_CHARACTER_REFERENCE : Xe(t) ? (this.state = i.NAMED_CHARACTER_REFERENCE, this._stateNamedCharacterReference(t)) : (this._flushCodePointConsumedAsCharacterReference(a.AMPERSAND), this._reconsumeInState(this.returnState, t));
  }
  _stateNamedCharacterReference(t) {
    const u = this._matchNamedCharacterReference(t);
    if (!this._ensureHibernation())
      if (u) {
        for (let s = 0; s < u.length; s++)
          this._flushCodePointConsumedAsCharacterReference(u[s]);
        this.state = this.returnState;
      } else
        this._flushCodePointConsumedAsCharacterReference(a.AMPERSAND), this.state = i.AMBIGUOUS_AMPERSAND;
  }
  _stateAmbiguousAmpersand(t) {
    Xe(t) ? this._flushCodePointConsumedAsCharacterReference(t) : (t === a.SEMICOLON && this._err(A.unknownNamedCharacterReference), this._reconsumeInState(this.returnState, t));
  }
  _stateNumericCharacterReference(t) {
    this.charRefCode = 0, t === a.LATIN_SMALL_X || t === a.LATIN_CAPITAL_X ? this.state = i.HEXADEMICAL_CHARACTER_REFERENCE_START : oe(t) ? (this.state = i.DECIMAL_CHARACTER_REFERENCE, this._stateDecimalCharacterReference(t)) : (this._err(A.absenceOfDigitsInNumericCharacterReference), this._flushCodePointConsumedAsCharacterReference(a.AMPERSAND), this._flushCodePointConsumedAsCharacterReference(a.NUMBER_SIGN), this._reconsumeInState(this.returnState, t));
  }
  _stateHexademicalCharacterReferenceStart(t) {
    Rn(t) ? (this.state = i.HEXADEMICAL_CHARACTER_REFERENCE, this._stateHexademicalCharacterReference(t)) : (this._err(A.absenceOfDigitsInNumericCharacterReference), this._flushCodePointConsumedAsCharacterReference(a.AMPERSAND), this._flushCodePointConsumedAsCharacterReference(a.NUMBER_SIGN), this._unconsume(2), this.state = this.returnState);
  }
  _stateHexademicalCharacterReference(t) {
    tu(t) ? this.charRefCode = this.charRefCode * 16 + t - 55 : uu(t) ? this.charRefCode = this.charRefCode * 16 + t - 87 : oe(t) ? this.charRefCode = this.charRefCode * 16 + t - 48 : t === a.SEMICOLON ? this.state = i.NUMERIC_CHARACTER_REFERENCE_END : (this._err(A.missingSemicolonAfterCharacterReference), this.state = i.NUMERIC_CHARACTER_REFERENCE_END, this._stateNumericCharacterReferenceEnd(t));
  }
  _stateDecimalCharacterReference(t) {
    oe(t) ? this.charRefCode = this.charRefCode * 10 + t - 48 : t === a.SEMICOLON ? this.state = i.NUMERIC_CHARACTER_REFERENCE_END : (this._err(A.missingSemicolonAfterCharacterReference), this.state = i.NUMERIC_CHARACTER_REFERENCE_END, this._stateNumericCharacterReferenceEnd(t));
  }
  _stateNumericCharacterReferenceEnd(t) {
    if (this.charRefCode === a.NULL)
      this._err(A.nullCharacterReference), this.charRefCode = a.REPLACEMENT_CHARACTER;
    else if (this.charRefCode > 1114111)
      this._err(A.characterReferenceOutsideUnicodeRange), this.charRefCode = a.REPLACEMENT_CHARACTER;
    else if (zt(this.charRefCode))
      this._err(A.surrogateCharacterReference), this.charRefCode = a.REPLACEMENT_CHARACTER;
    else if (Jt(this.charRefCode))
      this._err(A.noncharacterCharacterReference);
    else if (jt(this.charRefCode) || this.charRefCode === a.CARRIAGE_RETURN) {
      this._err(A.controlCharacterReference);
      const u = gn.get(this.charRefCode);
      u !== void 0 && (this.charRefCode = u);
    }
    this._flushCodePointConsumedAsCharacterReference(this.charRefCode), this._reconsumeInState(this.returnState, t);
  }
}
const su = /* @__PURE__ */ new Set([n.DD, n.DT, n.LI, n.OPTGROUP, n.OPTION, n.P, n.RB, n.RP, n.RT, n.RTC]), _t = /* @__PURE__ */ new Set([...su, n.CAPTION, n.COLGROUP, n.TBODY, n.TD, n.TFOOT, n.TH, n.THEAD, n.TR]), _e = /* @__PURE__ */ new Map([[n.APPLET, h.HTML], [n.CAPTION, h.HTML], [n.HTML, h.HTML], [n.MARQUEE, h.HTML], [n.OBJECT, h.HTML], [n.TABLE, h.HTML], [n.TD, h.HTML], [n.TEMPLATE, h.HTML], [n.TH, h.HTML], [n.ANNOTATION_XML, h.MATHML], [n.MI, h.MATHML], [n.MN, h.MATHML], [n.MO, h.MATHML], [n.MS, h.MATHML], [n.MTEXT, h.MATHML], [n.DESC, h.SVG], [n.FOREIGN_OBJECT, h.SVG], [n.TITLE, h.SVG]]), kn = [n.H1, n.H2, n.H3, n.H4, n.H5, n.H6], Mn = [n.TR, n.TEMPLATE, n.HTML], bn = [n.TBODY, n.TFOOT, n.THEAD, n.TEMPLATE, n.HTML], Pn = [n.TABLE, n.TEMPLATE, n.HTML], xn = [n.TD, n.TH];
class yn {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(t, u, s) {
    this.treeAdapter = u, this.handler = s, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = n.UNKNOWN, this.current = t;
  }
  _indexOf(t) {
    return this.items.lastIndexOf(t, this.stackTop);
  }
  _isInTemplate() {
    return this.currentTagId === n.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === h.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  push(t, u) {
    this.stackTop++, this.items[this.stackTop] = t, this.current = t, this.tagIDs[this.stackTop] = u, this.currentTagId = u, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(t, u, !0);
  }
  pop() {
    const t = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !0);
  }
  replace(t, u) {
    const s = this._indexOf(t);
    this.items[s] = u, s === this.stackTop && (this.current = u);
  }
  insertAfter(t, u, s) {
    const r = this._indexOf(t) + 1;
    this.items.splice(r, 0, u), this.tagIDs.splice(r, 0, s), this.stackTop++, r === this.stackTop && this._updateCurrentElement(), this.handler.onItemPush(this.current, this.currentTagId, r === this.stackTop);
  }
  popUntilTagNamePopped(t) {
    let u = this.stackTop + 1;
    do
      u = this.tagIDs.lastIndexOf(t, u - 1);
    while (u > 0 && this.treeAdapter.getNamespaceURI(this.items[u]) !== h.HTML);
    this.shortenToLength(u < 0 ? 0 : u);
  }
  shortenToLength(t) {
    for (; this.stackTop >= t; ) {
      const u = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(u, this.stackTop < t);
    }
  }
  popUntilElementPopped(t) {
    const u = this._indexOf(t);
    this.shortenToLength(u < 0 ? 0 : u);
  }
  popUntilPopped(t, u) {
    const s = this._indexOfTagNames(t, u);
    this.shortenToLength(s < 0 ? 0 : s);
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(kn, h.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(xn, h.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(t, u) {
    for (let s = this.stackTop; s >= 0; s--)
      if (t.includes(this.tagIDs[s]) && this.treeAdapter.getNamespaceURI(this.items[s]) === u)
        return s;
    return -1;
  }
  clearBackTo(t, u) {
    const s = this._indexOfTagNames(t, u);
    this.shortenToLength(s + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(Pn, h.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(bn, h.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(Mn, h.HTML);
  }
  remove(t) {
    const u = this._indexOf(t);
    u >= 0 && (u === this.stackTop ? this.pop() : (this.items.splice(u, 1), this.tagIDs.splice(u, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !1)));
  }
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === n.BODY ? this.items[1] : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    const u = this._indexOf(t) - 1;
    return u >= 0 ? this.items[u] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === n.HTML;
  }
  hasInScope(t) {
    for (let u = this.stackTop; u >= 0; u--) {
      const s = this.tagIDs[u], r = this.treeAdapter.getNamespaceURI(this.items[u]);
      if (s === t && r === h.HTML)
        return !0;
      if (_e.get(s) === r)
        return !1;
    }
    return !0;
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const u = this.tagIDs[t], s = this.treeAdapter.getNamespaceURI(this.items[t]);
      if (eu(u) && s === h.HTML)
        return !0;
      if (_e.get(u) === s)
        return !1;
    }
    return !0;
  }
  hasInListItemScope(t) {
    for (let u = this.stackTop; u >= 0; u--) {
      const s = this.tagIDs[u], r = this.treeAdapter.getNamespaceURI(this.items[u]);
      if (s === t && r === h.HTML)
        return !0;
      if ((s === n.UL || s === n.OL) && r === h.HTML || _e.get(s) === r)
        return !1;
    }
    return !0;
  }
  hasInButtonScope(t) {
    for (let u = this.stackTop; u >= 0; u--) {
      const s = this.tagIDs[u], r = this.treeAdapter.getNamespaceURI(this.items[u]);
      if (s === t && r === h.HTML)
        return !0;
      if (s === n.BUTTON && r === h.HTML || _e.get(s) === r)
        return !1;
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let u = this.stackTop; u >= 0; u--) {
      const s = this.tagIDs[u];
      if (this.treeAdapter.getNamespaceURI(this.items[u]) === h.HTML) {
        if (s === t)
          return !0;
        if (s === n.TABLE || s === n.TEMPLATE || s === n.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const u = this.tagIDs[t];
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === h.HTML) {
        if (u === n.TBODY || u === n.THEAD || u === n.TFOOT)
          return !0;
        if (u === n.TABLE || u === n.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasInSelectScope(t) {
    for (let u = this.stackTop; u >= 0; u--) {
      const s = this.tagIDs[u];
      if (this.treeAdapter.getNamespaceURI(this.items[u]) === h.HTML) {
        if (s === t)
          return !0;
        if (s !== n.OPTION && s !== n.OPTGROUP)
          return !1;
      }
    }
    return !0;
  }
  generateImpliedEndTags() {
    for (; su.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; _t.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; this.currentTagId !== t && _t.has(this.currentTagId); )
      this.pop();
  }
}
const Ue = 3;
var y;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(y = y || (y = {}));
const ft = { type: y.Marker };
class Un {
  constructor(t) {
    this.treeAdapter = t, this.entries = [], this.bookmark = null;
  }
  _getNoahArkConditionCandidates(t, u) {
    const s = [], r = u.length, o = this.treeAdapter.getTagName(t), E = this.treeAdapter.getNamespaceURI(t);
    for (let T = 0; T < this.entries.length; T++) {
      const p = this.entries[T];
      if (p.type === y.Marker)
        break;
      const { element: D } = p;
      if (this.treeAdapter.getTagName(D) === o && this.treeAdapter.getNamespaceURI(D) === E) {
        const m = this.treeAdapter.getAttrList(D);
        m.length === r && s.push({ idx: T, attrs: m });
      }
    }
    return s;
  }
  _ensureNoahArkCondition(t) {
    if (this.entries.length < Ue)
      return;
    const u = this.treeAdapter.getAttrList(t), s = this._getNoahArkConditionCandidates(t, u);
    if (s.length < Ue)
      return;
    const r = new Map(u.map((E) => [E.name, E.value]));
    let o = 0;
    for (let E = 0; E < s.length; E++) {
      const T = s[E];
      T.attrs.every((p) => r.get(p.name) === p.value) && (o += 1, o >= Ue && this.entries.splice(T.idx, 1));
    }
  }
  insertMarker() {
    this.entries.unshift(ft);
  }
  pushElement(t, u) {
    this._ensureNoahArkCondition(t), this.entries.unshift({ type: y.Element, element: t, token: u });
  }
  insertElementAfterBookmark(t, u) {
    const s = this.entries.indexOf(this.bookmark);
    this.entries.splice(s, 0, { type: y.Element, element: t, token: u });
  }
  removeEntry(t) {
    const u = this.entries.indexOf(t);
    u >= 0 && this.entries.splice(u, 1);
  }
  clearToLastMarker() {
    const t = this.entries.indexOf(ft);
    t >= 0 ? this.entries.splice(0, t + 1) : this.entries.length = 0;
  }
  getElementEntryInScopeWithTagName(t) {
    const u = this.entries.find((s) => s.type === y.Marker || this.treeAdapter.getTagName(s.element) === t);
    return u && u.type === y.Element ? u : null;
  }
  getElementEntry(t) {
    return this.entries.find((u) => u.type === y.Element && u.element === t);
  }
}
function Bt(e) {
  return { nodeName: "#text", value: e, parentNode: null };
}
const J = { createDocument() {
  return { nodeName: "#document", mode: P.NO_QUIRKS, childNodes: [] };
}, createDocumentFragment() {
  return { nodeName: "#document-fragment", childNodes: [] };
}, createElement(e, t, u) {
  return { nodeName: e, tagName: e, attrs: u, namespaceURI: t, childNodes: [], parentNode: null };
}, createCommentNode(e) {
  return { nodeName: "#comment", data: e, parentNode: null };
}, appendChild(e, t) {
  e.childNodes.push(t), t.parentNode = e;
}, insertBefore(e, t, u) {
  const s = e.childNodes.indexOf(u);
  e.childNodes.splice(s, 0, t), t.parentNode = e;
}, setTemplateContent(e, t) {
  e.content = t;
}, getTemplateContent(e) {
  return e.content;
}, setDocumentType(e, t, u, s) {
  const r = e.childNodes.find((o) => o.nodeName === "#documentType");
  if (r)
    r.name = t, r.publicId = u, r.systemId = s;
  else {
    const o = { nodeName: "#documentType", name: t, publicId: u, systemId: s, parentNode: null };
    J.appendChild(e, o);
  }
}, setDocumentMode(e, t) {
  e.mode = t;
}, getDocumentMode(e) {
  return e.mode;
}, detachNode(e) {
  if (e.parentNode) {
    const t = e.parentNode.childNodes.indexOf(e);
    e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
  }
}, insertText(e, t) {
  if (e.childNodes.length > 0) {
    const u = e.childNodes[e.childNodes.length - 1];
    if (J.isTextNode(u)) {
      u.value += t;
      return;
    }
  }
  J.appendChild(e, Bt(t));
}, insertTextBefore(e, t, u) {
  const s = e.childNodes[e.childNodes.indexOf(u) - 1];
  s && J.isTextNode(s) ? s.value += t : J.insertBefore(e, Bt(t), u);
}, adoptAttributes(e, t) {
  const u = new Set(e.attrs.map((s) => s.name));
  for (let s = 0; s < t.length; s++)
    u.has(t[s].name) || e.attrs.push(t[s]);
}, getFirstChild(e) {
  return e.childNodes[0];
}, getChildNodes(e) {
  return e.childNodes;
}, getParentNode(e) {
  return e.parentNode;
}, getAttrList(e) {
  return e.attrs;
}, getTagName(e) {
  return e.tagName;
}, getNamespaceURI(e) {
  return e.namespaceURI;
}, getTextNodeContent(e) {
  return e.value;
}, getCommentNodeContent(e) {
  return e.data;
}, getDocumentTypeNodeName(e) {
  return e.name;
}, getDocumentTypeNodePublicId(e) {
  return e.publicId;
}, getDocumentTypeNodeSystemId(e) {
  return e.systemId;
}, isTextNode(e) {
  return e.nodeName === "#text";
}, isCommentNode(e) {
  return e.nodeName === "#comment";
}, isDocumentTypeNode(e) {
  return e.nodeName === "#documentType";
}, isElementNode(e) {
  return Object.prototype.hasOwnProperty.call(e, "tagName");
}, setNodeSourceCodeLocation(e, t) {
  e.sourceCodeLocation = t;
}, getNodeSourceCodeLocation(e) {
  return e.sourceCodeLocation;
}, updateNodeSourceCodeLocation(e, t) {
  e.sourceCodeLocation = { ...e.sourceCodeLocation, ...t };
} }, au = "html", Hn = "about:legacy-compat", wn = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", ru = ["+//silmaril//dtd html pro v0r11 19970101//", "-//as//dtd html 3.0 aswedit + extensions//", "-//advasoft ltd//dtd html 3.0 aswedit + extensions//", "-//ietf//dtd html 2.0 level 1//", "-//ietf//dtd html 2.0 level 2//", "-//ietf//dtd html 2.0 strict level 1//", "-//ietf//dtd html 2.0 strict level 2//", "-//ietf//dtd html 2.0 strict//", "-//ietf//dtd html 2.0//", "-//ietf//dtd html 2.1e//", "-//ietf//dtd html 3.0//", "-//ietf//dtd html 3.2 final//", "-//ietf//dtd html 3.2//", "-//ietf//dtd html 3//", "-//ietf//dtd html level 0//", "-//ietf//dtd html level 1//", "-//ietf//dtd html level 2//", "-//ietf//dtd html level 3//", "-//ietf//dtd html strict level 0//", "-//ietf//dtd html strict level 1//", "-//ietf//dtd html strict level 2//", "-//ietf//dtd html strict level 3//", "-//ietf//dtd html strict//", "-//ietf//dtd html//", "-//metrius//dtd metrius presentational//", "-//microsoft//dtd internet explorer 2.0 html strict//", "-//microsoft//dtd internet explorer 2.0 html//", "-//microsoft//dtd internet explorer 2.0 tables//", "-//microsoft//dtd internet explorer 3.0 html strict//", "-//microsoft//dtd internet explorer 3.0 html//", "-//microsoft//dtd internet explorer 3.0 tables//", "-//netscape comm. corp.//dtd html//", "-//netscape comm. corp.//dtd strict html//", "-//o'reilly and associates//dtd html 2.0//", "-//o'reilly and associates//dtd html extended 1.0//", "-//o'reilly and associates//dtd html extended relaxed 1.0//", "-//sq//dtd html 2.0 hotmetal + extensions//", "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//", "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//", "-//spyglass//dtd html 2.0 extended//", "-//sun microsystems corp.//dtd hotjava html//", "-//sun microsystems corp.//dtd hotjava strict html//", "-//w3c//dtd html 3 1995-03-24//", "-//w3c//dtd html 3.2 draft//", "-//w3c//dtd html 3.2 final//", "-//w3c//dtd html 3.2//", "-//w3c//dtd html 3.2s draft//", "-//w3c//dtd html 4.0 frameset//", "-//w3c//dtd html 4.0 transitional//", "-//w3c//dtd html experimental 19960712//", "-//w3c//dtd html experimental 970421//", "-//w3c//dtd w3 html//", "-//w3o//dtd w3 html 3.0//", "-//webtechs//dtd mozilla html 2.0//", "-//webtechs//dtd mozilla html//"], Gn = [...ru, "-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"], vn = /* @__PURE__ */ new Set(["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"]), iu = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], Yn = [...iu, "-//w3c//dtd html 4.01 frameset//", "-//w3c//dtd html 4.01 transitional//"];
function It(e, t) {
  return t.some((u) => e.startsWith(u));
}
function qn(e) {
  return e.name === au && e.publicId === null && (e.systemId === null || e.systemId === Hn);
}
function Wn(e) {
  if (e.name !== au)
    return P.QUIRKS;
  const { systemId: t } = e;
  if (t && t.toLowerCase() === wn)
    return P.QUIRKS;
  let { publicId: u } = e;
  if (u !== null) {
    if (u = u.toLowerCase(), vn.has(u))
      return P.QUIRKS;
    let s = t === null ? Gn : ru;
    if (It(u, s))
      return P.QUIRKS;
    if (s = t === null ? iu : Yn, It(u, s))
      return P.LIMITED_QUIRKS;
  }
  return P.NO_QUIRKS;
}
const Nt = { TEXT_HTML: "text/html", APPLICATION_XML: "application/xhtml+xml" }, Qn = "definitionurl", Xn = "definitionURL", Kn = new Map(["attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", "maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", "yChannelSelector", "zoomAndPan"].map((e) => [e.toLowerCase(), e])), Vn = /* @__PURE__ */ new Map([["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: h.XLINK }], ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: h.XLINK }], ["xlink:href", { prefix: "xlink", name: "href", namespace: h.XLINK }], ["xlink:role", { prefix: "xlink", name: "role", namespace: h.XLINK }], ["xlink:show", { prefix: "xlink", name: "show", namespace: h.XLINK }], ["xlink:title", { prefix: "xlink", name: "title", namespace: h.XLINK }], ["xlink:type", { prefix: "xlink", name: "type", namespace: h.XLINK }], ["xml:base", { prefix: "xml", name: "base", namespace: h.XML }], ["xml:lang", { prefix: "xml", name: "lang", namespace: h.XML }], ["xml:space", { prefix: "xml", name: "space", namespace: h.XML }], ["xmlns", { prefix: "", name: "xmlns", namespace: h.XMLNS }], ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: h.XMLNS }]]), zn = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map((e) => [e.toLowerCase(), e])), jn = /* @__PURE__ */ new Set([n.B, n.BIG, n.BLOCKQUOTE, n.BODY, n.BR, n.CENTER, n.CODE, n.DD, n.DIV, n.DL, n.DT, n.EM, n.EMBED, n.H1, n.H2, n.H3, n.H4, n.H5, n.H6, n.HEAD, n.HR, n.I, n.IMG, n.LI, n.LISTING, n.MENU, n.META, n.NOBR, n.OL, n.P, n.PRE, n.RUBY, n.S, n.SMALL, n.SPAN, n.STRONG, n.STRIKE, n.SUB, n.SUP, n.TABLE, n.TT, n.U, n.UL, n.VAR]);
function Jn(e) {
  const t = e.tagID;
  return t === n.FONT && e.attrs.some(({ name: u }) => u === W.COLOR || u === W.SIZE || u === W.FACE) || jn.has(t);
}
function ou(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === Qn) {
      e.attrs[t].name = Xn;
      break;
    }
}
function cu(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const u = Kn.get(e.attrs[t].name);
    u != null && (e.attrs[t].name = u);
  }
}
function et(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const u = Vn.get(e.attrs[t].name);
    u && (e.attrs[t].prefix = u.prefix, e.attrs[t].name = u.name, e.attrs[t].namespace = u.namespace);
  }
}
function Zn(e) {
  const t = zn.get(e.tagName);
  t != null && (e.tagName = t, e.tagID = Re(e.tagName));
}
function $n(e, t) {
  return t === h.MATHML && (e === n.MI || e === n.MO || e === n.MN || e === n.MS || e === n.MTEXT);
}
function es(e, t, u) {
  if (t === h.MATHML && e === n.ANNOTATION_XML) {
    for (let s = 0; s < u.length; s++)
      if (u[s].name === W.ENCODING) {
        const r = u[s].value.toLowerCase();
        return r === Nt.TEXT_HTML || r === Nt.APPLICATION_XML;
      }
  }
  return t === h.SVG && (e === n.FOREIGN_OBJECT || e === n.DESC || e === n.TITLE);
}
function ts(e, t, u, s) {
  return (!s || s === h.HTML) && es(e, t, u) || (!s || s === h.MATHML) && $n(e, t);
}
const us = "hidden", ns = 8, ss = 3;
var c;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(c || (c = {}));
const as = { startLine: -1, startCol: -1, startOffset: -1, endLine: -1, endCol: -1, endOffset: -1 }, Eu = /* @__PURE__ */ new Set([n.TABLE, n.TBODY, n.TFOOT, n.THEAD, n.TR]), St = { scriptingEnabled: !0, sourceCodeLocationInfo: !1, treeAdapter: J, onParseError: null };
class lu {
  constructor(t, u, s = null, r = null) {
    this.fragmentContext = s, this.scriptHandler = r, this.currentToken = null, this.stopped = !1, this.insertionMode = c.INITIAL, this.originalInsertionMode = c.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = { ...St, ...t }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = u ?? this.treeAdapter.createDocument(), this.tokenizer = new Ln(this.options, this), this.activeFormattingElements = new Un(this.treeAdapter), this.fragmentContextID = s ? Re(this.treeAdapter.getTagName(s)) : n.UNKNOWN, this._setContextModes(s ?? this.document, this.fragmentContextID), this.openElements = new yn(this.document, this.treeAdapter, this);
  }
  static parse(t, u) {
    const s = new this(u);
    return s.tokenizer.write(t, !0), s.document;
  }
  static getFragmentParser(t, u) {
    const s = { ...St, ...u };
    t ?? (t = s.treeAdapter.createElement(l.TEMPLATE, h.HTML, []));
    const r = s.treeAdapter.createElement("documentmock", h.HTML, []), o = new this(s, r, t);
    return o.fragmentContextID === n.TEMPLATE && o.tmplInsertionModeStack.unshift(c.IN_TEMPLATE), o._initTokenizerForFragmentParsing(), o._insertFakeRootElement(), o._resetInsertionMode(), o._findFormInFragmentContext(), o;
  }
  getFragment() {
    const t = this.treeAdapter.getFirstChild(this.document), u = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(t, u), u;
  }
  _err(t, u, s) {
    var r;
    if (!this.onParseError)
      return;
    const o = (r = t.location) !== null && r !== void 0 ? r : as, E = { code: u, startLine: o.startLine, startCol: o.startCol, startOffset: o.startOffset, endLine: s ? o.startLine : o.endLine, endCol: s ? o.startCol : o.endCol, endOffset: s ? o.startOffset : o.endOffset };
    this.onParseError(E);
  }
  onItemPush(t, u, s) {
    var r, o;
    (o = (r = this.treeAdapter).onItemPush) === null || o === void 0 || o.call(r, t), s && this.openElements.stackTop > 0 && this._setContextModes(t, u);
  }
  onItemPop(t, u) {
    var s, r;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(t, this.currentToken), (r = (s = this.treeAdapter).onItemPop) === null || r === void 0 || r.call(s, t, this.openElements.current), u) {
      let o, E;
      this.openElements.stackTop === 0 && this.fragmentContext ? (o = this.fragmentContext, E = this.fragmentContextID) : { current: o, currentTagId: E } = this.openElements, this._setContextModes(o, E);
    }
  }
  _setContextModes(t, u) {
    const s = t === this.document || this.treeAdapter.getNamespaceURI(t) === h.HTML;
    this.currentNotInHTML = !s, this.tokenizer.inForeignNode = !s && !this._isIntegrationPoint(u, t);
  }
  _switchToTextParsing(t, u) {
    this._insertElement(t, h.HTML), this.tokenizer.state = u, this.originalInsertionMode = this.insertionMode, this.insertionMode = c.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = c.TEXT, this.originalInsertionMode = c.IN_BODY, this.tokenizer.state = k.PLAINTEXT;
  }
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    for (; t; ) {
      if (this.treeAdapter.getTagName(t) === l.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== h.HTML))
      switch (this.fragmentContextID) {
        case n.TITLE:
        case n.TEXTAREA: {
          this.tokenizer.state = k.RCDATA;
          break;
        }
        case n.STYLE:
        case n.XMP:
        case n.IFRAME:
        case n.NOEMBED:
        case n.NOFRAMES:
        case n.NOSCRIPT: {
          this.tokenizer.state = k.RAWTEXT;
          break;
        }
        case n.SCRIPT: {
          this.tokenizer.state = k.SCRIPT_DATA;
          break;
        }
        case n.PLAINTEXT: {
          this.tokenizer.state = k.PLAINTEXT;
          break;
        }
      }
  }
  _setDocumentType(t) {
    const u = t.name || "", s = t.publicId || "", r = t.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, u, s, r), t.location) {
      const o = this.treeAdapter.getChildNodes(this.document).find((E) => this.treeAdapter.isDocumentTypeNode(E));
      o && this.treeAdapter.setNodeSourceCodeLocation(o, t.location);
    }
  }
  _attachElementToTree(t, u) {
    if (this.options.sourceCodeLocationInfo) {
      const s = u && { ...u, startTag: u };
      this.treeAdapter.setNodeSourceCodeLocation(t, s);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const s = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(s, t);
    }
  }
  _appendElement(t, u) {
    const s = this.treeAdapter.createElement(t.tagName, u, t.attrs);
    this._attachElementToTree(s, t.location);
  }
  _insertElement(t, u) {
    const s = this.treeAdapter.createElement(t.tagName, u, t.attrs);
    this._attachElementToTree(s, t.location), this.openElements.push(s, t.tagID);
  }
  _insertFakeElement(t, u) {
    const s = this.treeAdapter.createElement(t, h.HTML, []);
    this._attachElementToTree(s, null), this.openElements.push(s, u);
  }
  _insertTemplate(t) {
    const u = this.treeAdapter.createElement(t.tagName, h.HTML, t.attrs), s = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(u, s), this._attachElementToTree(u, t.location), this.openElements.push(u, t.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(s, null);
  }
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(l.HTML, h.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(t, null), this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t, n.HTML);
  }
  _appendCommentNode(t, u) {
    const s = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(u, s), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(s, t.location);
  }
  _insertCharacters(t) {
    let u, s;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: u, beforeElement: s } = this._findFosterParentingLocation(), s ? this.treeAdapter.insertTextBefore(u, t.chars, s) : this.treeAdapter.insertText(u, t.chars)) : (u = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(u, t.chars)), !t.location)
      return;
    const r = this.treeAdapter.getChildNodes(u), o = s ? r.lastIndexOf(s) : r.length, E = r[o - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(E)) {
      const { endLine: T, endCol: p, endOffset: D } = t.location;
      this.treeAdapter.updateNodeSourceCodeLocation(E, { endLine: T, endCol: p, endOffset: D });
    } else
      this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(E, t.location);
  }
  _adoptNodes(t, u) {
    for (let s = this.treeAdapter.getFirstChild(t); s; s = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(s), this.treeAdapter.appendChild(u, s);
  }
  _setEndLocation(t, u) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && u.location) {
      const s = u.location, r = this.treeAdapter.getTagName(t), o = u.type === f.END_TAG && r === u.tagName ? { endTag: { ...s }, endLine: s.endLine, endCol: s.endCol, endOffset: s.endOffset } : { endLine: s.startLine, endCol: s.startCol, endOffset: s.startOffset };
      this.treeAdapter.updateNodeSourceCodeLocation(t, o);
    }
  }
  shouldProcessStartTagTokenInForeignContent(t) {
    if (!this.currentNotInHTML)
      return !1;
    let u, s;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (u = this.fragmentContext, s = this.fragmentContextID) : { current: u, currentTagId: s } = this.openElements, t.tagID === n.SVG && this.treeAdapter.getTagName(u) === l.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(u) === h.MATHML ? !1 : this.tokenizer.inForeignNode || (t.tagID === n.MGLYPH || t.tagID === n.MALIGNMARK) && !this._isIntegrationPoint(s, u, h.HTML);
  }
  _processToken(t) {
    switch (t.type) {
      case f.CHARACTER: {
        this.onCharacter(t);
        break;
      }
      case f.NULL_CHARACTER: {
        this.onNullCharacter(t);
        break;
      }
      case f.COMMENT: {
        this.onComment(t);
        break;
      }
      case f.DOCTYPE: {
        this.onDoctype(t);
        break;
      }
      case f.START_TAG: {
        this._processStartTag(t);
        break;
      }
      case f.END_TAG: {
        this.onEndTag(t);
        break;
      }
      case f.EOF: {
        this.onEof(t);
        break;
      }
      case f.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(t);
        break;
      }
    }
  }
  _isIntegrationPoint(t, u, s) {
    const r = this.treeAdapter.getNamespaceURI(u), o = this.treeAdapter.getAttrList(u);
    return ts(t, r, o, s);
  }
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.entries.length;
    if (t) {
      const u = this.activeFormattingElements.entries.findIndex((r) => r.type === y.Marker || this.openElements.contains(r.element)), s = u < 0 ? t - 1 : u - 1;
      for (let r = s; r >= 0; r--) {
        const o = this.activeFormattingElements.entries[r];
        this._insertElement(o.token, this.treeAdapter.getNamespaceURI(o.element)), o.element = this.openElements.current;
      }
    }
  }
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = c.IN_ROW;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(n.P), this.openElements.popUntilTagNamePopped(n.P);
  }
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop; t >= 0; t--)
      switch (t === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[t]) {
        case n.TR: {
          this.insertionMode = c.IN_ROW;
          return;
        }
        case n.TBODY:
        case n.THEAD:
        case n.TFOOT: {
          this.insertionMode = c.IN_TABLE_BODY;
          return;
        }
        case n.CAPTION: {
          this.insertionMode = c.IN_CAPTION;
          return;
        }
        case n.COLGROUP: {
          this.insertionMode = c.IN_COLUMN_GROUP;
          return;
        }
        case n.TABLE: {
          this.insertionMode = c.IN_TABLE;
          return;
        }
        case n.BODY: {
          this.insertionMode = c.IN_BODY;
          return;
        }
        case n.FRAMESET: {
          this.insertionMode = c.IN_FRAMESET;
          return;
        }
        case n.SELECT: {
          this._resetInsertionModeForSelect(t);
          return;
        }
        case n.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case n.HTML: {
          this.insertionMode = this.headElement ? c.AFTER_HEAD : c.BEFORE_HEAD;
          return;
        }
        case n.TD:
        case n.TH: {
          if (t > 0) {
            this.insertionMode = c.IN_CELL;
            return;
          }
          break;
        }
        case n.HEAD: {
          if (t > 0) {
            this.insertionMode = c.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = c.IN_BODY;
  }
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let u = t - 1; u > 0; u--) {
        const s = this.openElements.tagIDs[u];
        if (s === n.TEMPLATE)
          break;
        if (s === n.TABLE) {
          this.insertionMode = c.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = c.IN_SELECT;
  }
  _isElementCausesFosterParenting(t) {
    return Eu.has(t);
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  _findFosterParentingLocation() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      const u = this.openElements.items[t];
      switch (this.openElements.tagIDs[t]) {
        case n.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(u) === h.HTML)
            return { parent: this.treeAdapter.getTemplateContent(u), beforeElement: null };
          break;
        }
        case n.TABLE: {
          const s = this.treeAdapter.getParentNode(u);
          return s ? { parent: s, beforeElement: u } : { parent: this.openElements.items[t - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  _fosterParentElement(t) {
    const u = this._findFosterParentingLocation();
    u.beforeElement ? this.treeAdapter.insertBefore(u.parent, t, u.beforeElement) : this.treeAdapter.appendChild(u.parent, t);
  }
  _isSpecialElement(t, u) {
    const s = this.treeAdapter.getNamespaceURI(t);
    return Sn[s].has(u);
  }
  onCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      xa(this, t);
      return;
    }
    switch (this.insertionMode) {
      case c.INITIAL: {
        ne(this, t);
        break;
      }
      case c.BEFORE_HTML: {
        ce(this, t);
        break;
      }
      case c.BEFORE_HEAD: {
        Ee(this, t);
        break;
      }
      case c.IN_HEAD: {
        le(this, t);
        break;
      }
      case c.IN_HEAD_NO_SCRIPT: {
        Ae(this, t);
        break;
      }
      case c.AFTER_HEAD: {
        he(this, t);
        break;
      }
      case c.IN_BODY:
      case c.IN_CAPTION:
      case c.IN_CELL:
      case c.IN_TEMPLATE: {
        hu(this, t);
        break;
      }
      case c.TEXT:
      case c.IN_SELECT:
      case c.IN_SELECT_IN_TABLE: {
        this._insertCharacters(t);
        break;
      }
      case c.IN_TABLE:
      case c.IN_TABLE_BODY:
      case c.IN_ROW: {
        He(this, t);
        break;
      }
      case c.IN_TABLE_TEXT: {
        mu(this, t);
        break;
      }
      case c.IN_COLUMN_GROUP: {
        Ne(this, t);
        break;
      }
      case c.AFTER_BODY: {
        Se(this, t);
        break;
      }
      case c.AFTER_AFTER_BODY: {
        Ie(this, t);
        break;
      }
    }
  }
  onNullCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      Pa(this, t);
      return;
    }
    switch (this.insertionMode) {
      case c.INITIAL: {
        ne(this, t);
        break;
      }
      case c.BEFORE_HTML: {
        ce(this, t);
        break;
      }
      case c.BEFORE_HEAD: {
        Ee(this, t);
        break;
      }
      case c.IN_HEAD: {
        le(this, t);
        break;
      }
      case c.IN_HEAD_NO_SCRIPT: {
        Ae(this, t);
        break;
      }
      case c.AFTER_HEAD: {
        he(this, t);
        break;
      }
      case c.TEXT: {
        this._insertCharacters(t);
        break;
      }
      case c.IN_TABLE:
      case c.IN_TABLE_BODY:
      case c.IN_ROW: {
        He(this, t);
        break;
      }
      case c.IN_COLUMN_GROUP: {
        Ne(this, t);
        break;
      }
      case c.AFTER_BODY: {
        Se(this, t);
        break;
      }
      case c.AFTER_AFTER_BODY: {
        Ie(this, t);
        break;
      }
    }
  }
  onComment(t) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      Ke(this, t);
      return;
    }
    switch (this.insertionMode) {
      case c.INITIAL:
      case c.BEFORE_HTML:
      case c.BEFORE_HEAD:
      case c.IN_HEAD:
      case c.IN_HEAD_NO_SCRIPT:
      case c.AFTER_HEAD:
      case c.IN_BODY:
      case c.IN_TABLE:
      case c.IN_CAPTION:
      case c.IN_COLUMN_GROUP:
      case c.IN_TABLE_BODY:
      case c.IN_ROW:
      case c.IN_CELL:
      case c.IN_SELECT:
      case c.IN_SELECT_IN_TABLE:
      case c.IN_TEMPLATE:
      case c.IN_FRAMESET:
      case c.AFTER_FRAMESET: {
        Ke(this, t);
        break;
      }
      case c.IN_TABLE_TEXT: {
        se(this, t);
        break;
      }
      case c.AFTER_BODY: {
        As(this, t);
        break;
      }
      case c.AFTER_AFTER_BODY:
      case c.AFTER_AFTER_FRAMESET: {
        hs(this, t);
        break;
      }
    }
  }
  onDoctype(t) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case c.INITIAL: {
        Ts(this, t);
        break;
      }
      case c.BEFORE_HEAD:
      case c.IN_HEAD:
      case c.IN_HEAD_NO_SCRIPT:
      case c.AFTER_HEAD: {
        this._err(t, A.misplacedDoctype);
        break;
      }
      case c.IN_TABLE_TEXT: {
        se(this, t);
        break;
      }
    }
  }
  onStartTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this._processStartTag(t), t.selfClosing && !t.ackSelfClosing && this._err(t, A.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  _processStartTag(t) {
    this.shouldProcessStartTagTokenInForeignContent(t) ? ya(this, t) : this._startTagOutsideForeignContent(t);
  }
  _startTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case c.INITIAL: {
        ne(this, t);
        break;
      }
      case c.BEFORE_HTML: {
        ps(this, t);
        break;
      }
      case c.BEFORE_HEAD: {
        Cs(this, t);
        break;
      }
      case c.IN_HEAD: {
        U(this, t);
        break;
      }
      case c.IN_HEAD_NO_SCRIPT: {
        _s(this, t);
        break;
      }
      case c.AFTER_HEAD: {
        Bs(this, t);
        break;
      }
      case c.IN_BODY: {
        R(this, t);
        break;
      }
      case c.IN_TABLE: {
        ee(this, t);
        break;
      }
      case c.IN_TABLE_TEXT: {
        se(this, t);
        break;
      }
      case c.IN_CAPTION: {
        Da(this, t);
        break;
      }
      case c.IN_COLUMN_GROUP: {
        nt(this, t);
        break;
      }
      case c.IN_TABLE_BODY: {
        ke(this, t);
        break;
      }
      case c.IN_ROW: {
        Me(this, t);
        break;
      }
      case c.IN_CELL: {
        fa(this, t);
        break;
      }
      case c.IN_SELECT: {
        Bu(this, t);
        break;
      }
      case c.IN_SELECT_IN_TABLE: {
        Ia(this, t);
        break;
      }
      case c.IN_TEMPLATE: {
        Sa(this, t);
        break;
      }
      case c.AFTER_BODY: {
        Fa(this, t);
        break;
      }
      case c.IN_FRAMESET: {
        Ra(this, t);
        break;
      }
      case c.AFTER_FRAMESET: {
        La(this, t);
        break;
      }
      case c.AFTER_AFTER_BODY: {
        Ma(this, t);
        break;
      }
      case c.AFTER_AFTER_FRAMESET: {
        ba(this, t);
        break;
      }
    }
  }
  onEndTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this.currentNotInHTML ? Ua(this, t) : this._endTagOutsideForeignContent(t);
  }
  _endTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case c.INITIAL: {
        ne(this, t);
        break;
      }
      case c.BEFORE_HTML: {
        ds(this, t);
        break;
      }
      case c.BEFORE_HEAD: {
        Ds(this, t);
        break;
      }
      case c.IN_HEAD: {
        ms(this, t);
        break;
      }
      case c.IN_HEAD_NO_SCRIPT: {
        fs(this, t);
        break;
      }
      case c.AFTER_HEAD: {
        Is(this, t);
        break;
      }
      case c.IN_BODY: {
        Le(this, t);
        break;
      }
      case c.TEXT: {
        oa(this, t);
        break;
      }
      case c.IN_TABLE: {
        pe(this, t);
        break;
      }
      case c.IN_TABLE_TEXT: {
        se(this, t);
        break;
      }
      case c.IN_CAPTION: {
        ma(this, t);
        break;
      }
      case c.IN_COLUMN_GROUP: {
        _a(this, t);
        break;
      }
      case c.IN_TABLE_BODY: {
        Ve(this, t);
        break;
      }
      case c.IN_ROW: {
        fu(this, t);
        break;
      }
      case c.IN_CELL: {
        Ba(this, t);
        break;
      }
      case c.IN_SELECT: {
        Iu(this, t);
        break;
      }
      case c.IN_SELECT_IN_TABLE: {
        Na(this, t);
        break;
      }
      case c.IN_TEMPLATE: {
        ga(this, t);
        break;
      }
      case c.AFTER_BODY: {
        Su(this, t);
        break;
      }
      case c.IN_FRAMESET: {
        Oa(this, t);
        break;
      }
      case c.AFTER_FRAMESET: {
        ka(this, t);
        break;
      }
      case c.AFTER_AFTER_BODY: {
        Ie(this, t);
        break;
      }
    }
  }
  onEof(t) {
    switch (this.insertionMode) {
      case c.INITIAL: {
        ne(this, t);
        break;
      }
      case c.BEFORE_HTML: {
        ce(this, t);
        break;
      }
      case c.BEFORE_HEAD: {
        Ee(this, t);
        break;
      }
      case c.IN_HEAD: {
        le(this, t);
        break;
      }
      case c.IN_HEAD_NO_SCRIPT: {
        Ae(this, t);
        break;
      }
      case c.AFTER_HEAD: {
        he(this, t);
        break;
      }
      case c.IN_BODY:
      case c.IN_TABLE:
      case c.IN_CAPTION:
      case c.IN_COLUMN_GROUP:
      case c.IN_TABLE_BODY:
      case c.IN_ROW:
      case c.IN_CELL:
      case c.IN_SELECT:
      case c.IN_SELECT_IN_TABLE: {
        Cu(this, t);
        break;
      }
      case c.TEXT: {
        ca(this, t);
        break;
      }
      case c.IN_TABLE_TEXT: {
        se(this, t);
        break;
      }
      case c.IN_TEMPLATE: {
        Nu(this, t);
        break;
      }
      case c.AFTER_BODY:
      case c.IN_FRAMESET:
      case c.AFTER_FRAMESET:
      case c.AFTER_AFTER_BODY:
      case c.AFTER_AFTER_FRAMESET: {
        ut(this, t);
        break;
      }
    }
  }
  onWhitespaceCharacter(t) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, t.chars.charCodeAt(0) === a.LINE_FEED)) {
      if (t.chars.length === 1)
        return;
      t.chars = t.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(t);
      return;
    }
    switch (this.insertionMode) {
      case c.IN_HEAD:
      case c.IN_HEAD_NO_SCRIPT:
      case c.AFTER_HEAD:
      case c.TEXT:
      case c.IN_COLUMN_GROUP:
      case c.IN_SELECT:
      case c.IN_SELECT_IN_TABLE:
      case c.IN_FRAMESET:
      case c.AFTER_FRAMESET: {
        this._insertCharacters(t);
        break;
      }
      case c.IN_BODY:
      case c.IN_CAPTION:
      case c.IN_CELL:
      case c.IN_TEMPLATE:
      case c.AFTER_BODY:
      case c.AFTER_AFTER_BODY:
      case c.AFTER_AFTER_FRAMESET: {
        Au(this, t);
        break;
      }
      case c.IN_TABLE:
      case c.IN_TABLE_BODY:
      case c.IN_ROW: {
        He(this, t);
        break;
      }
      case c.IN_TABLE_TEXT: {
        Du(this, t);
        break;
      }
    }
  }
}
function rs(e, t) {
  let u = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return u ? e.openElements.contains(u.element) ? e.openElements.hasInScope(t.tagID) || (u = null) : (e.activeFormattingElements.removeEntry(u), u = null) : du(e, t), u;
}
function is(e, t) {
  let u = null, s = e.openElements.stackTop;
  for (; s >= 0; s--) {
    const r = e.openElements.items[s];
    if (r === t.element)
      break;
    e._isSpecialElement(r, e.openElements.tagIDs[s]) && (u = r);
  }
  return u || (e.openElements.shortenToLength(s < 0 ? 0 : s), e.activeFormattingElements.removeEntry(t)), u;
}
function os(e, t, u) {
  let s = t, r = e.openElements.getCommonAncestor(t);
  for (let o = 0, E = r; E !== u; o++, E = r) {
    r = e.openElements.getCommonAncestor(E);
    const T = e.activeFormattingElements.getElementEntry(E), p = T && o >= ss;
    !T || p ? (p && e.activeFormattingElements.removeEntry(T), e.openElements.remove(E)) : (E = cs(e, T), s === t && (e.activeFormattingElements.bookmark = T), e.treeAdapter.detachNode(s), e.treeAdapter.appendChild(E, s), s = E);
  }
  return s;
}
function cs(e, t) {
  const u = e.treeAdapter.getNamespaceURI(t.element), s = e.treeAdapter.createElement(t.token.tagName, u, t.token.attrs);
  return e.openElements.replace(t.element, s), t.element = s, s;
}
function Es(e, t, u) {
  const s = e.treeAdapter.getTagName(t), r = Re(s);
  if (e._isElementCausesFosterParenting(r))
    e._fosterParentElement(u);
  else {
    const o = e.treeAdapter.getNamespaceURI(t);
    r === n.TEMPLATE && o === h.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, u);
  }
}
function ls(e, t, u) {
  const s = e.treeAdapter.getNamespaceURI(u.element), { token: r } = u, o = e.treeAdapter.createElement(r.tagName, s, r.attrs);
  e._adoptNodes(t, o), e.treeAdapter.appendChild(t, o), e.activeFormattingElements.insertElementAfterBookmark(o, r), e.activeFormattingElements.removeEntry(u), e.openElements.remove(u.element), e.openElements.insertAfter(t, o, r.tagID);
}
function tt(e, t) {
  for (let u = 0; u < ns; u++) {
    const s = rs(e, t);
    if (!s)
      break;
    const r = is(e, s);
    if (!r)
      break;
    e.activeFormattingElements.bookmark = s;
    const o = os(e, r, s.element), E = e.openElements.getCommonAncestor(s.element);
    e.treeAdapter.detachNode(o), E && Es(e, E, o), ls(e, r, s);
  }
}
function Ke(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContentOrNode);
}
function As(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function hs(e, t) {
  e._appendCommentNode(t, e.document);
}
function ut(e, t) {
  if (e.stopped = !0, t.location) {
    const u = e.fragmentContext ? 0 : 2;
    for (let s = e.openElements.stackTop; s >= u; s--)
      e._setEndLocation(e.openElements.items[s], t);
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const s = e.openElements.items[0], r = e.treeAdapter.getNodeSourceCodeLocation(s);
      if (r && !r.endTag && (e._setEndLocation(s, t), e.openElements.stackTop >= 1)) {
        const o = e.openElements.items[1], E = e.treeAdapter.getNodeSourceCodeLocation(o);
        E && !E.endTag && e._setEndLocation(o, t);
      }
    }
  }
}
function Ts(e, t) {
  e._setDocumentType(t);
  const u = t.forceQuirks ? P.QUIRKS : Wn(t);
  qn(t) || e._err(t, A.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, u), e.insertionMode = c.BEFORE_HTML;
}
function ne(e, t) {
  e._err(t, A.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, P.QUIRKS), e.insertionMode = c.BEFORE_HTML, e._processToken(t);
}
function ps(e, t) {
  t.tagID === n.HTML ? (e._insertElement(t, h.HTML), e.insertionMode = c.BEFORE_HEAD) : ce(e, t);
}
function ds(e, t) {
  const u = t.tagID;
  (u === n.HTML || u === n.HEAD || u === n.BODY || u === n.BR) && ce(e, t);
}
function ce(e, t) {
  e._insertFakeRootElement(), e.insertionMode = c.BEFORE_HEAD, e._processToken(t);
}
function Cs(e, t) {
  switch (t.tagID) {
    case n.HTML: {
      R(e, t);
      break;
    }
    case n.HEAD: {
      e._insertElement(t, h.HTML), e.headElement = e.openElements.current, e.insertionMode = c.IN_HEAD;
      break;
    }
    default:
      Ee(e, t);
  }
}
function Ds(e, t) {
  const u = t.tagID;
  u === n.HEAD || u === n.BODY || u === n.HTML || u === n.BR ? Ee(e, t) : e._err(t, A.endTagWithoutMatchingOpenElement);
}
function Ee(e, t) {
  e._insertFakeElement(l.HEAD, n.HEAD), e.headElement = e.openElements.current, e.insertionMode = c.IN_HEAD, e._processToken(t);
}
function U(e, t) {
  switch (t.tagID) {
    case n.HTML: {
      R(e, t);
      break;
    }
    case n.BASE:
    case n.BASEFONT:
    case n.BGSOUND:
    case n.LINK:
    case n.META: {
      e._appendElement(t, h.HTML), t.ackSelfClosing = !0;
      break;
    }
    case n.TITLE: {
      e._switchToTextParsing(t, k.RCDATA);
      break;
    }
    case n.NOSCRIPT: {
      e.options.scriptingEnabled ? e._switchToTextParsing(t, k.RAWTEXT) : (e._insertElement(t, h.HTML), e.insertionMode = c.IN_HEAD_NO_SCRIPT);
      break;
    }
    case n.NOFRAMES:
    case n.STYLE: {
      e._switchToTextParsing(t, k.RAWTEXT);
      break;
    }
    case n.SCRIPT: {
      e._switchToTextParsing(t, k.SCRIPT_DATA);
      break;
    }
    case n.TEMPLATE: {
      e._insertTemplate(t), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = c.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(c.IN_TEMPLATE);
      break;
    }
    case n.HEAD: {
      e._err(t, A.misplacedStartTagForHeadElement);
      break;
    }
    default:
      le(e, t);
  }
}
function ms(e, t) {
  switch (t.tagID) {
    case n.HEAD: {
      e.openElements.pop(), e.insertionMode = c.AFTER_HEAD;
      break;
    }
    case n.BODY:
    case n.BR:
    case n.HTML: {
      le(e, t);
      break;
    }
    case n.TEMPLATE: {
      V(e, t);
      break;
    }
    default:
      e._err(t, A.endTagWithoutMatchingOpenElement);
  }
}
function V(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== n.TEMPLATE && e._err(t, A.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(n.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(t, A.endTagWithoutMatchingOpenElement);
}
function le(e, t) {
  e.openElements.pop(), e.insertionMode = c.AFTER_HEAD, e._processToken(t);
}
function _s(e, t) {
  switch (t.tagID) {
    case n.HTML: {
      R(e, t);
      break;
    }
    case n.BASEFONT:
    case n.BGSOUND:
    case n.HEAD:
    case n.LINK:
    case n.META:
    case n.NOFRAMES:
    case n.STYLE: {
      U(e, t);
      break;
    }
    case n.NOSCRIPT: {
      e._err(t, A.nestedNoscriptInHead);
      break;
    }
    default:
      Ae(e, t);
  }
}
function fs(e, t) {
  switch (t.tagID) {
    case n.NOSCRIPT: {
      e.openElements.pop(), e.insertionMode = c.IN_HEAD;
      break;
    }
    case n.BR: {
      Ae(e, t);
      break;
    }
    default:
      e._err(t, A.endTagWithoutMatchingOpenElement);
  }
}
function Ae(e, t) {
  const u = t.type === f.EOF ? A.openElementsLeftAfterEof : A.disallowedContentInNoscriptInHead;
  e._err(t, u), e.openElements.pop(), e.insertionMode = c.IN_HEAD, e._processToken(t);
}
function Bs(e, t) {
  switch (t.tagID) {
    case n.HTML: {
      R(e, t);
      break;
    }
    case n.BODY: {
      e._insertElement(t, h.HTML), e.framesetOk = !1, e.insertionMode = c.IN_BODY;
      break;
    }
    case n.FRAMESET: {
      e._insertElement(t, h.HTML), e.insertionMode = c.IN_FRAMESET;
      break;
    }
    case n.BASE:
    case n.BASEFONT:
    case n.BGSOUND:
    case n.LINK:
    case n.META:
    case n.NOFRAMES:
    case n.SCRIPT:
    case n.STYLE:
    case n.TEMPLATE:
    case n.TITLE: {
      e._err(t, A.abandonedHeadElementChild), e.openElements.push(e.headElement, n.HEAD), U(e, t), e.openElements.remove(e.headElement);
      break;
    }
    case n.HEAD: {
      e._err(t, A.misplacedStartTagForHeadElement);
      break;
    }
    default:
      he(e, t);
  }
}
function Is(e, t) {
  switch (t.tagID) {
    case n.BODY:
    case n.HTML:
    case n.BR: {
      he(e, t);
      break;
    }
    case n.TEMPLATE: {
      V(e, t);
      break;
    }
    default:
      e._err(t, A.endTagWithoutMatchingOpenElement);
  }
}
function he(e, t) {
  e._insertFakeElement(l.BODY, n.BODY), e.insertionMode = c.IN_BODY, Oe(e, t);
}
function Oe(e, t) {
  switch (t.type) {
    case f.CHARACTER: {
      hu(e, t);
      break;
    }
    case f.WHITESPACE_CHARACTER: {
      Au(e, t);
      break;
    }
    case f.COMMENT: {
      Ke(e, t);
      break;
    }
    case f.START_TAG: {
      R(e, t);
      break;
    }
    case f.END_TAG: {
      Le(e, t);
      break;
    }
    case f.EOF: {
      Cu(e, t);
      break;
    }
  }
}
function Au(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function hu(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function Ns(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function Ss(e, t) {
  const u = e.openElements.tryPeekProperlyNestedBodyElement();
  u && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(u, t.attrs));
}
function gs(e, t) {
  const u = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && u && (e.treeAdapter.detachNode(u), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, h.HTML), e.insertionMode = c.IN_FRAMESET);
}
function Fs(e, t) {
  e.openElements.hasInButtonScope(n.P) && e._closePElement(), e._insertElement(t, h.HTML);
}
function Rs(e, t) {
  e.openElements.hasInButtonScope(n.P) && e._closePElement(), eu(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(t, h.HTML);
}
function Os(e, t) {
  e.openElements.hasInButtonScope(n.P) && e._closePElement(), e._insertElement(t, h.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function Ls(e, t) {
  const u = e.openElements.tmplCount > 0;
  (!e.formElement || u) && (e.openElements.hasInButtonScope(n.P) && e._closePElement(), e._insertElement(t, h.HTML), u || (e.formElement = e.openElements.current));
}
function ks(e, t) {
  e.framesetOk = !1;
  const u = t.tagID;
  for (let s = e.openElements.stackTop; s >= 0; s--) {
    const r = e.openElements.tagIDs[s];
    if (u === n.LI && r === n.LI || (u === n.DD || u === n.DT) && (r === n.DD || r === n.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.popUntilTagNamePopped(r);
      break;
    }
    if (r !== n.ADDRESS && r !== n.DIV && r !== n.P && e._isSpecialElement(e.openElements.items[s], r))
      break;
  }
  e.openElements.hasInButtonScope(n.P) && e._closePElement(), e._insertElement(t, h.HTML);
}
function Ms(e, t) {
  e.openElements.hasInButtonScope(n.P) && e._closePElement(), e._insertElement(t, h.HTML), e.tokenizer.state = k.PLAINTEXT;
}
function bs(e, t) {
  e.openElements.hasInScope(n.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, h.HTML), e.framesetOk = !1;
}
function Ps(e, t) {
  const u = e.activeFormattingElements.getElementEntryInScopeWithTagName(l.A);
  u && (tt(e, t), e.openElements.remove(u.element), e.activeFormattingElements.removeEntry(u)), e._reconstructActiveFormattingElements(), e._insertElement(t, h.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function xs(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, h.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function ys(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(n.NOBR) && (tt(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, h.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Us(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, h.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function Hs(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== P.QUIRKS && e.openElements.hasInButtonScope(n.P) && e._closePElement(), e._insertElement(t, h.HTML), e.framesetOk = !1, e.insertionMode = c.IN_TABLE;
}
function Tu(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, h.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function pu(e) {
  const t = Zt(e, W.TYPE);
  return t != null && t.toLowerCase() === us;
}
function ws(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, h.HTML), pu(t) || (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function Gs(e, t) {
  e._appendElement(t, h.HTML), t.ackSelfClosing = !0;
}
function vs(e, t) {
  e.openElements.hasInButtonScope(n.P) && e._closePElement(), e._appendElement(t, h.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function Ys(e, t) {
  t.tagName = l.IMG, t.tagID = n.IMG, Tu(e, t);
}
function qs(e, t) {
  e._insertElement(t, h.HTML), e.skipNextNewLine = !0, e.tokenizer.state = k.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = c.TEXT;
}
function Ws(e, t) {
  e.openElements.hasInButtonScope(n.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, k.RAWTEXT);
}
function Qs(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, k.RAWTEXT);
}
function gt(e, t) {
  e._switchToTextParsing(t, k.RAWTEXT);
}
function Xs(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, h.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === c.IN_TABLE || e.insertionMode === c.IN_CAPTION || e.insertionMode === c.IN_TABLE_BODY || e.insertionMode === c.IN_ROW || e.insertionMode === c.IN_CELL ? c.IN_SELECT_IN_TABLE : c.IN_SELECT;
}
function Ks(e, t) {
  e.openElements.currentTagId === n.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, h.HTML);
}
function Vs(e, t) {
  e.openElements.hasInScope(n.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, h.HTML);
}
function zs(e, t) {
  e.openElements.hasInScope(n.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(n.RTC), e._insertElement(t, h.HTML);
}
function js(e, t) {
  e._reconstructActiveFormattingElements(), ou(t), et(t), t.selfClosing ? e._appendElement(t, h.MATHML) : e._insertElement(t, h.MATHML), t.ackSelfClosing = !0;
}
function Js(e, t) {
  e._reconstructActiveFormattingElements(), cu(t), et(t), t.selfClosing ? e._appendElement(t, h.SVG) : e._insertElement(t, h.SVG), t.ackSelfClosing = !0;
}
function Ft(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, h.HTML);
}
function R(e, t) {
  switch (t.tagID) {
    case n.I:
    case n.S:
    case n.B:
    case n.U:
    case n.EM:
    case n.TT:
    case n.BIG:
    case n.CODE:
    case n.FONT:
    case n.SMALL:
    case n.STRIKE:
    case n.STRONG: {
      xs(e, t);
      break;
    }
    case n.A: {
      Ps(e, t);
      break;
    }
    case n.H1:
    case n.H2:
    case n.H3:
    case n.H4:
    case n.H5:
    case n.H6: {
      Rs(e, t);
      break;
    }
    case n.P:
    case n.DL:
    case n.OL:
    case n.UL:
    case n.DIV:
    case n.DIR:
    case n.NAV:
    case n.MAIN:
    case n.MENU:
    case n.ASIDE:
    case n.CENTER:
    case n.FIGURE:
    case n.FOOTER:
    case n.HEADER:
    case n.HGROUP:
    case n.DIALOG:
    case n.DETAILS:
    case n.ADDRESS:
    case n.ARTICLE:
    case n.SECTION:
    case n.SUMMARY:
    case n.FIELDSET:
    case n.BLOCKQUOTE:
    case n.FIGCAPTION: {
      Fs(e, t);
      break;
    }
    case n.LI:
    case n.DD:
    case n.DT: {
      ks(e, t);
      break;
    }
    case n.BR:
    case n.IMG:
    case n.WBR:
    case n.AREA:
    case n.EMBED:
    case n.KEYGEN: {
      Tu(e, t);
      break;
    }
    case n.HR: {
      vs(e, t);
      break;
    }
    case n.RB:
    case n.RTC: {
      Vs(e, t);
      break;
    }
    case n.RT:
    case n.RP: {
      zs(e, t);
      break;
    }
    case n.PRE:
    case n.LISTING: {
      Os(e, t);
      break;
    }
    case n.XMP: {
      Ws(e, t);
      break;
    }
    case n.SVG: {
      Js(e, t);
      break;
    }
    case n.HTML: {
      Ns(e, t);
      break;
    }
    case n.BASE:
    case n.LINK:
    case n.META:
    case n.STYLE:
    case n.TITLE:
    case n.SCRIPT:
    case n.BGSOUND:
    case n.BASEFONT:
    case n.TEMPLATE: {
      U(e, t);
      break;
    }
    case n.BODY: {
      Ss(e, t);
      break;
    }
    case n.FORM: {
      Ls(e, t);
      break;
    }
    case n.NOBR: {
      ys(e, t);
      break;
    }
    case n.MATH: {
      js(e, t);
      break;
    }
    case n.TABLE: {
      Hs(e, t);
      break;
    }
    case n.INPUT: {
      ws(e, t);
      break;
    }
    case n.PARAM:
    case n.TRACK:
    case n.SOURCE: {
      Gs(e, t);
      break;
    }
    case n.IMAGE: {
      Ys(e, t);
      break;
    }
    case n.BUTTON: {
      bs(e, t);
      break;
    }
    case n.APPLET:
    case n.OBJECT:
    case n.MARQUEE: {
      Us(e, t);
      break;
    }
    case n.IFRAME: {
      Qs(e, t);
      break;
    }
    case n.SELECT: {
      Xs(e, t);
      break;
    }
    case n.OPTION:
    case n.OPTGROUP: {
      Ks(e, t);
      break;
    }
    case n.NOEMBED: {
      gt(e, t);
      break;
    }
    case n.FRAMESET: {
      gs(e, t);
      break;
    }
    case n.TEXTAREA: {
      qs(e, t);
      break;
    }
    case n.NOSCRIPT: {
      e.options.scriptingEnabled ? gt(e, t) : Ft(e, t);
      break;
    }
    case n.PLAINTEXT: {
      Ms(e, t);
      break;
    }
    case n.COL:
    case n.TH:
    case n.TD:
    case n.TR:
    case n.HEAD:
    case n.FRAME:
    case n.TBODY:
    case n.TFOOT:
    case n.THEAD:
    case n.CAPTION:
    case n.COLGROUP:
      break;
    default:
      Ft(e, t);
  }
}
function Zs(e, t) {
  if (e.openElements.hasInScope(n.BODY) && (e.insertionMode = c.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const u = e.openElements.tryPeekProperlyNestedBodyElement();
    u && e._setEndLocation(u, t);
  }
}
function $s(e, t) {
  e.openElements.hasInScope(n.BODY) && (e.insertionMode = c.AFTER_BODY, Su(e, t));
}
function ea(e, t) {
  const u = t.tagID;
  e.openElements.hasInScope(u) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(u));
}
function ta(e) {
  const t = e.openElements.tmplCount > 0, { formElement: u } = e;
  t || (e.formElement = null), (u || t) && e.openElements.hasInScope(n.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(n.FORM) : u && e.openElements.remove(u));
}
function ua(e) {
  e.openElements.hasInButtonScope(n.P) || e._insertFakeElement(l.P, n.P), e._closePElement();
}
function na(e) {
  e.openElements.hasInListItemScope(n.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(n.LI), e.openElements.popUntilTagNamePopped(n.LI));
}
function sa(e, t) {
  const u = t.tagID;
  e.openElements.hasInScope(u) && (e.openElements.generateImpliedEndTagsWithExclusion(u), e.openElements.popUntilTagNamePopped(u));
}
function aa(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function ra(e, t) {
  const u = t.tagID;
  e.openElements.hasInScope(u) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(u), e.activeFormattingElements.clearToLastMarker());
}
function ia(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(l.BR, n.BR), e.openElements.pop(), e.framesetOk = !1;
}
function du(e, t) {
  const u = t.tagName, s = t.tagID;
  for (let r = e.openElements.stackTop; r > 0; r--) {
    const o = e.openElements.items[r], E = e.openElements.tagIDs[r];
    if (s === E && (s !== n.UNKNOWN || e.treeAdapter.getTagName(o) === u)) {
      e.openElements.generateImpliedEndTagsWithExclusion(s), e.openElements.stackTop >= r && e.openElements.shortenToLength(r);
      break;
    }
    if (e._isSpecialElement(o, E))
      break;
  }
}
function Le(e, t) {
  switch (t.tagID) {
    case n.A:
    case n.B:
    case n.I:
    case n.S:
    case n.U:
    case n.EM:
    case n.TT:
    case n.BIG:
    case n.CODE:
    case n.FONT:
    case n.NOBR:
    case n.SMALL:
    case n.STRIKE:
    case n.STRONG: {
      tt(e, t);
      break;
    }
    case n.P: {
      ua(e);
      break;
    }
    case n.DL:
    case n.UL:
    case n.OL:
    case n.DIR:
    case n.DIV:
    case n.NAV:
    case n.PRE:
    case n.MAIN:
    case n.MENU:
    case n.ASIDE:
    case n.BUTTON:
    case n.CENTER:
    case n.FIGURE:
    case n.FOOTER:
    case n.HEADER:
    case n.HGROUP:
    case n.DIALOG:
    case n.ADDRESS:
    case n.ARTICLE:
    case n.DETAILS:
    case n.SECTION:
    case n.SUMMARY:
    case n.LISTING:
    case n.FIELDSET:
    case n.BLOCKQUOTE:
    case n.FIGCAPTION: {
      ea(e, t);
      break;
    }
    case n.LI: {
      na(e);
      break;
    }
    case n.DD:
    case n.DT: {
      sa(e, t);
      break;
    }
    case n.H1:
    case n.H2:
    case n.H3:
    case n.H4:
    case n.H5:
    case n.H6: {
      aa(e);
      break;
    }
    case n.BR: {
      ia(e);
      break;
    }
    case n.BODY: {
      Zs(e, t);
      break;
    }
    case n.HTML: {
      $s(e, t);
      break;
    }
    case n.FORM: {
      ta(e);
      break;
    }
    case n.APPLET:
    case n.OBJECT:
    case n.MARQUEE: {
      ra(e, t);
      break;
    }
    case n.TEMPLATE: {
      V(e, t);
      break;
    }
    default:
      du(e, t);
  }
}
function Cu(e, t) {
  e.tmplInsertionModeStack.length > 0 ? Nu(e, t) : ut(e, t);
}
function oa(e, t) {
  var u;
  t.tagID === n.SCRIPT && ((u = e.scriptHandler) === null || u === void 0 || u.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function ca(e, t) {
  e._err(t, A.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(t);
}
function He(e, t) {
  if (Eu.has(e.openElements.currentTagId))
    switch (e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = c.IN_TABLE_TEXT, t.type) {
      case f.CHARACTER: {
        mu(e, t);
        break;
      }
      case f.WHITESPACE_CHARACTER: {
        Du(e, t);
        break;
      }
    }
  else
    de(e, t);
}
function Ea(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, h.HTML), e.insertionMode = c.IN_CAPTION;
}
function la(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, h.HTML), e.insertionMode = c.IN_COLUMN_GROUP;
}
function Aa(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(l.COLGROUP, n.COLGROUP), e.insertionMode = c.IN_COLUMN_GROUP, nt(e, t);
}
function ha(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, h.HTML), e.insertionMode = c.IN_TABLE_BODY;
}
function Ta(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(l.TBODY, n.TBODY), e.insertionMode = c.IN_TABLE_BODY, ke(e, t);
}
function pa(e, t) {
  e.openElements.hasInTableScope(n.TABLE) && (e.openElements.popUntilTagNamePopped(n.TABLE), e._resetInsertionMode(), e._processStartTag(t));
}
function da(e, t) {
  pu(t) ? e._appendElement(t, h.HTML) : de(e, t), t.ackSelfClosing = !0;
}
function Ca(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, h.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function ee(e, t) {
  switch (t.tagID) {
    case n.TD:
    case n.TH:
    case n.TR: {
      Ta(e, t);
      break;
    }
    case n.STYLE:
    case n.SCRIPT:
    case n.TEMPLATE: {
      U(e, t);
      break;
    }
    case n.COL: {
      Aa(e, t);
      break;
    }
    case n.FORM: {
      Ca(e, t);
      break;
    }
    case n.TABLE: {
      pa(e, t);
      break;
    }
    case n.TBODY:
    case n.TFOOT:
    case n.THEAD: {
      ha(e, t);
      break;
    }
    case n.INPUT: {
      da(e, t);
      break;
    }
    case n.CAPTION: {
      Ea(e, t);
      break;
    }
    case n.COLGROUP: {
      la(e, t);
      break;
    }
    default:
      de(e, t);
  }
}
function pe(e, t) {
  switch (t.tagID) {
    case n.TABLE: {
      e.openElements.hasInTableScope(n.TABLE) && (e.openElements.popUntilTagNamePopped(n.TABLE), e._resetInsertionMode());
      break;
    }
    case n.TEMPLATE: {
      V(e, t);
      break;
    }
    case n.BODY:
    case n.CAPTION:
    case n.COL:
    case n.COLGROUP:
    case n.HTML:
    case n.TBODY:
    case n.TD:
    case n.TFOOT:
    case n.TH:
    case n.THEAD:
    case n.TR:
      break;
    default:
      de(e, t);
  }
}
function de(e, t) {
  const u = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, Oe(e, t), e.fosterParentingEnabled = u;
}
function Du(e, t) {
  e.pendingCharacterTokens.push(t);
}
function mu(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function se(e, t) {
  let u = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; u < e.pendingCharacterTokens.length; u++)
      de(e, e.pendingCharacterTokens[u]);
  else
    for (; u < e.pendingCharacterTokens.length; u++)
      e._insertCharacters(e.pendingCharacterTokens[u]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
const _u = /* @__PURE__ */ new Set([n.CAPTION, n.COL, n.COLGROUP, n.TBODY, n.TD, n.TFOOT, n.TH, n.THEAD, n.TR]);
function Da(e, t) {
  const u = t.tagID;
  _u.has(u) ? e.openElements.hasInTableScope(n.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = c.IN_TABLE, ee(e, t)) : R(e, t);
}
function ma(e, t) {
  const u = t.tagID;
  switch (u) {
    case n.CAPTION:
    case n.TABLE: {
      e.openElements.hasInTableScope(n.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = c.IN_TABLE, u === n.TABLE && pe(e, t));
      break;
    }
    case n.BODY:
    case n.COL:
    case n.COLGROUP:
    case n.HTML:
    case n.TBODY:
    case n.TD:
    case n.TFOOT:
    case n.TH:
    case n.THEAD:
    case n.TR:
      break;
    default:
      Le(e, t);
  }
}
function nt(e, t) {
  switch (t.tagID) {
    case n.HTML: {
      R(e, t);
      break;
    }
    case n.COL: {
      e._appendElement(t, h.HTML), t.ackSelfClosing = !0;
      break;
    }
    case n.TEMPLATE: {
      U(e, t);
      break;
    }
    default:
      Ne(e, t);
  }
}
function _a(e, t) {
  switch (t.tagID) {
    case n.COLGROUP: {
      e.openElements.currentTagId === n.COLGROUP && (e.openElements.pop(), e.insertionMode = c.IN_TABLE);
      break;
    }
    case n.TEMPLATE: {
      V(e, t);
      break;
    }
    case n.COL:
      break;
    default:
      Ne(e, t);
  }
}
function Ne(e, t) {
  e.openElements.currentTagId === n.COLGROUP && (e.openElements.pop(), e.insertionMode = c.IN_TABLE, e._processToken(t));
}
function ke(e, t) {
  switch (t.tagID) {
    case n.TR: {
      e.openElements.clearBackToTableBodyContext(), e._insertElement(t, h.HTML), e.insertionMode = c.IN_ROW;
      break;
    }
    case n.TH:
    case n.TD: {
      e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(l.TR, n.TR), e.insertionMode = c.IN_ROW, Me(e, t);
      break;
    }
    case n.CAPTION:
    case n.COL:
    case n.COLGROUP:
    case n.TBODY:
    case n.TFOOT:
    case n.THEAD: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = c.IN_TABLE, ee(e, t));
      break;
    }
    default:
      ee(e, t);
  }
}
function Ve(e, t) {
  const u = t.tagID;
  switch (t.tagID) {
    case n.TBODY:
    case n.TFOOT:
    case n.THEAD: {
      e.openElements.hasInTableScope(u) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = c.IN_TABLE);
      break;
    }
    case n.TABLE: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = c.IN_TABLE, pe(e, t));
      break;
    }
    case n.BODY:
    case n.CAPTION:
    case n.COL:
    case n.COLGROUP:
    case n.HTML:
    case n.TD:
    case n.TH:
    case n.TR:
      break;
    default:
      pe(e, t);
  }
}
function Me(e, t) {
  switch (t.tagID) {
    case n.TH:
    case n.TD: {
      e.openElements.clearBackToTableRowContext(), e._insertElement(t, h.HTML), e.insertionMode = c.IN_CELL, e.activeFormattingElements.insertMarker();
      break;
    }
    case n.CAPTION:
    case n.COL:
    case n.COLGROUP:
    case n.TBODY:
    case n.TFOOT:
    case n.THEAD:
    case n.TR: {
      e.openElements.hasInTableScope(n.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = c.IN_TABLE_BODY, ke(e, t));
      break;
    }
    default:
      ee(e, t);
  }
}
function fu(e, t) {
  switch (t.tagID) {
    case n.TR: {
      e.openElements.hasInTableScope(n.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = c.IN_TABLE_BODY);
      break;
    }
    case n.TABLE: {
      e.openElements.hasInTableScope(n.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = c.IN_TABLE_BODY, Ve(e, t));
      break;
    }
    case n.TBODY:
    case n.TFOOT:
    case n.THEAD: {
      (e.openElements.hasInTableScope(t.tagID) || e.openElements.hasInTableScope(n.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = c.IN_TABLE_BODY, Ve(e, t));
      break;
    }
    case n.BODY:
    case n.CAPTION:
    case n.COL:
    case n.COLGROUP:
    case n.HTML:
    case n.TD:
    case n.TH:
      break;
    default:
      pe(e, t);
  }
}
function fa(e, t) {
  const u = t.tagID;
  _u.has(u) ? (e.openElements.hasInTableScope(n.TD) || e.openElements.hasInTableScope(n.TH)) && (e._closeTableCell(), Me(e, t)) : R(e, t);
}
function Ba(e, t) {
  const u = t.tagID;
  switch (u) {
    case n.TD:
    case n.TH: {
      e.openElements.hasInTableScope(u) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(u), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = c.IN_ROW);
      break;
    }
    case n.TABLE:
    case n.TBODY:
    case n.TFOOT:
    case n.THEAD:
    case n.TR: {
      e.openElements.hasInTableScope(u) && (e._closeTableCell(), fu(e, t));
      break;
    }
    case n.BODY:
    case n.CAPTION:
    case n.COL:
    case n.COLGROUP:
    case n.HTML:
      break;
    default:
      Le(e, t);
  }
}
function Bu(e, t) {
  switch (t.tagID) {
    case n.HTML: {
      R(e, t);
      break;
    }
    case n.OPTION: {
      e.openElements.currentTagId === n.OPTION && e.openElements.pop(), e._insertElement(t, h.HTML);
      break;
    }
    case n.OPTGROUP: {
      e.openElements.currentTagId === n.OPTION && e.openElements.pop(), e.openElements.currentTagId === n.OPTGROUP && e.openElements.pop(), e._insertElement(t, h.HTML);
      break;
    }
    case n.INPUT:
    case n.KEYGEN:
    case n.TEXTAREA:
    case n.SELECT: {
      e.openElements.hasInSelectScope(n.SELECT) && (e.openElements.popUntilTagNamePopped(n.SELECT), e._resetInsertionMode(), t.tagID !== n.SELECT && e._processStartTag(t));
      break;
    }
    case n.SCRIPT:
    case n.TEMPLATE: {
      U(e, t);
      break;
    }
  }
}
function Iu(e, t) {
  switch (t.tagID) {
    case n.OPTGROUP: {
      e.openElements.stackTop > 0 && e.openElements.currentTagId === n.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === n.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === n.OPTGROUP && e.openElements.pop();
      break;
    }
    case n.OPTION: {
      e.openElements.currentTagId === n.OPTION && e.openElements.pop();
      break;
    }
    case n.SELECT: {
      e.openElements.hasInSelectScope(n.SELECT) && (e.openElements.popUntilTagNamePopped(n.SELECT), e._resetInsertionMode());
      break;
    }
    case n.TEMPLATE: {
      V(e, t);
      break;
    }
  }
}
function Ia(e, t) {
  const u = t.tagID;
  u === n.CAPTION || u === n.TABLE || u === n.TBODY || u === n.TFOOT || u === n.THEAD || u === n.TR || u === n.TD || u === n.TH ? (e.openElements.popUntilTagNamePopped(n.SELECT), e._resetInsertionMode(), e._processStartTag(t)) : Bu(e, t);
}
function Na(e, t) {
  const u = t.tagID;
  u === n.CAPTION || u === n.TABLE || u === n.TBODY || u === n.TFOOT || u === n.THEAD || u === n.TR || u === n.TD || u === n.TH ? e.openElements.hasInTableScope(u) && (e.openElements.popUntilTagNamePopped(n.SELECT), e._resetInsertionMode(), e.onEndTag(t)) : Iu(e, t);
}
function Sa(e, t) {
  switch (t.tagID) {
    case n.BASE:
    case n.BASEFONT:
    case n.BGSOUND:
    case n.LINK:
    case n.META:
    case n.NOFRAMES:
    case n.SCRIPT:
    case n.STYLE:
    case n.TEMPLATE:
    case n.TITLE: {
      U(e, t);
      break;
    }
    case n.CAPTION:
    case n.COLGROUP:
    case n.TBODY:
    case n.TFOOT:
    case n.THEAD: {
      e.tmplInsertionModeStack[0] = c.IN_TABLE, e.insertionMode = c.IN_TABLE, ee(e, t);
      break;
    }
    case n.COL: {
      e.tmplInsertionModeStack[0] = c.IN_COLUMN_GROUP, e.insertionMode = c.IN_COLUMN_GROUP, nt(e, t);
      break;
    }
    case n.TR: {
      e.tmplInsertionModeStack[0] = c.IN_TABLE_BODY, e.insertionMode = c.IN_TABLE_BODY, ke(e, t);
      break;
    }
    case n.TD:
    case n.TH: {
      e.tmplInsertionModeStack[0] = c.IN_ROW, e.insertionMode = c.IN_ROW, Me(e, t);
      break;
    }
    default:
      e.tmplInsertionModeStack[0] = c.IN_BODY, e.insertionMode = c.IN_BODY, R(e, t);
  }
}
function ga(e, t) {
  t.tagID === n.TEMPLATE && V(e, t);
}
function Nu(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(n.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(t)) : ut(e, t);
}
function Fa(e, t) {
  t.tagID === n.HTML ? R(e, t) : Se(e, t);
}
function Su(e, t) {
  var u;
  if (t.tagID === n.HTML) {
    if (e.fragmentContext || (e.insertionMode = c.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === n.HTML) {
      e._setEndLocation(e.openElements.items[0], t);
      const s = e.openElements.items[1];
      s && !(!((u = e.treeAdapter.getNodeSourceCodeLocation(s)) === null || u === void 0) && u.endTag) && e._setEndLocation(s, t);
    }
  } else
    Se(e, t);
}
function Se(e, t) {
  e.insertionMode = c.IN_BODY, Oe(e, t);
}
function Ra(e, t) {
  switch (t.tagID) {
    case n.HTML: {
      R(e, t);
      break;
    }
    case n.FRAMESET: {
      e._insertElement(t, h.HTML);
      break;
    }
    case n.FRAME: {
      e._appendElement(t, h.HTML), t.ackSelfClosing = !0;
      break;
    }
    case n.NOFRAMES: {
      U(e, t);
      break;
    }
  }
}
function Oa(e, t) {
  t.tagID === n.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== n.FRAMESET && (e.insertionMode = c.AFTER_FRAMESET));
}
function La(e, t) {
  switch (t.tagID) {
    case n.HTML: {
      R(e, t);
      break;
    }
    case n.NOFRAMES: {
      U(e, t);
      break;
    }
  }
}
function ka(e, t) {
  t.tagID === n.HTML && (e.insertionMode = c.AFTER_AFTER_FRAMESET);
}
function Ma(e, t) {
  t.tagID === n.HTML ? R(e, t) : Ie(e, t);
}
function Ie(e, t) {
  e.insertionMode = c.IN_BODY, Oe(e, t);
}
function ba(e, t) {
  switch (t.tagID) {
    case n.HTML: {
      R(e, t);
      break;
    }
    case n.NOFRAMES: {
      U(e, t);
      break;
    }
  }
}
function Pa(e, t) {
  t.chars = I, e._insertCharacters(t);
}
function xa(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function gu(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== h.HTML && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current); )
    e.openElements.pop();
}
function ya(e, t) {
  if (Jn(t))
    gu(e), e._startTagOutsideForeignContent(t);
  else {
    const u = e._getAdjustedCurrentElement(), s = e.treeAdapter.getNamespaceURI(u);
    s === h.MATHML ? ou(t) : s === h.SVG && (Zn(t), cu(t)), et(t), t.selfClosing ? e._appendElement(t, s) : e._insertElement(t, s), t.ackSelfClosing = !0;
  }
}
function Ua(e, t) {
  if (t.tagID === n.P || t.tagID === n.BR) {
    gu(e), e._endTagOutsideForeignContent(t);
    return;
  }
  for (let u = e.openElements.stackTop; u > 0; u--) {
    const s = e.openElements.items[u];
    if (e.treeAdapter.getNamespaceURI(s) === h.HTML) {
      e._endTagOutsideForeignContent(t);
      break;
    }
    const r = e.treeAdapter.getTagName(s);
    if (r.toLowerCase() === t.tagName) {
      t.tagName = r, e.openElements.shortenToLength(u);
      break;
    }
  }
}
l.AREA, l.BASE, l.BASEFONT, l.BGSOUND, l.BR, l.COL, l.EMBED, l.FRAME, l.HR, l.IMG, l.INPUT, l.KEYGEN, l.LINK, l.META, l.PARAM, l.SOURCE, l.TRACK, l.WBR;
function Ha(e, t) {
  return lu.parse(e, t);
}
function wa(e, t, u) {
  typeof e == "string" && (u = t, t = e, e = null);
  const s = lu.getFragmentParser(e, u);
  return s.tokenizer.write(t, !0), s.getFragment();
}
class O extends Error {
  constructor(t, u, s) {
    super(), typeof u == "string" && (s = u, u = void 0);
    let r = "", o = {}, E = !1;
    if (u && ("line" in u && "column" in u ? o = { place: u } : "start" in u && "end" in u ? o = { place: u } : "type" in u ? o = { ancestors: [u], place: u.position } : o = { ...u }), typeof t == "string" ? r = t : !o.cause && t && (E = !0, r = t.message, o.cause = t), !o.ruleId && !o.source && typeof s == "string") {
      const p = s.indexOf(":");
      p === -1 ? o.ruleId = s : (o.source = s.slice(0, p), o.ruleId = s.slice(p + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const p = o.ancestors[o.ancestors.length - 1];
      p && (o.place = p.position);
    }
    const T = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = T ? T.column : void 0, this.fatal = void 0, this.file, this.message = r, this.line = T ? T.line : void 0, this.name = wu(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = E && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
O.prototype.file = "", O.prototype.name = "", O.prototype.reason = "", O.prototype.message = "", O.prototype.stack = "", O.prototype.column = void 0, O.prototype.line = void 0, O.prototype.ancestors = void 0, O.prototype.cause = void 0, O.prototype.fatal = void 0, O.prototype.place = void 0, O.prototype.ruleId = void 0, O.prototype.source = void 0;
const H = { basename: Ga, dirname: va, extname: Ya, join: qa, sep: "/" };
function Ga(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Ce(e);
  let u = 0, s = -1, r = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; r--; )
      if (e.codePointAt(r) === 47) {
        if (o) {
          u = r + 1;
          break;
        }
      } else
        s < 0 && (o = !0, s = r + 1);
    return s < 0 ? "" : e.slice(u, s);
  }
  if (t === e)
    return "";
  let E = -1, T = t.length - 1;
  for (; r--; )
    if (e.codePointAt(r) === 47) {
      if (o) {
        u = r + 1;
        break;
      }
    } else
      E < 0 && (o = !0, E = r + 1), T > -1 && (e.codePointAt(r) === t.codePointAt(T--) ? T < 0 && (s = r) : (T = -1, s = E));
  return u === s ? s = E : s < 0 && (s = e.length), e.slice(u, s);
}
function va(e) {
  if (Ce(e), e.length === 0)
    return ".";
  let t = -1, u = e.length, s;
  for (; --u; )
    if (e.codePointAt(u) === 47) {
      if (s) {
        t = u;
        break;
      }
    } else
      s || (s = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function Ya(e) {
  Ce(e);
  let t = e.length, u = -1, s = 0, r = -1, o = 0, E;
  for (; t--; ) {
    const T = e.codePointAt(t);
    if (T === 47) {
      if (E) {
        s = t + 1;
        break;
      }
      continue;
    }
    u < 0 && (E = !0, u = t + 1), T === 46 ? r < 0 ? r = t : o !== 1 && (o = 1) : r > -1 && (o = -1);
  }
  return r < 0 || u < 0 || o === 0 || o === 1 && r === u - 1 && r === s + 1 ? "" : e.slice(r, u);
}
function qa(...e) {
  let t = -1, u;
  for (; ++t < e.length; )
    Ce(e[t]), e[t] && (u = u === void 0 ? e[t] : u + "/" + e[t]);
  return u === void 0 ? "." : Wa(u);
}
function Wa(e) {
  Ce(e);
  const t = e.codePointAt(0) === 47;
  let u = Qa(e, !t);
  return u.length === 0 && !t && (u = "."), u.length > 0 && e.codePointAt(e.length - 1) === 47 && (u += "/"), t ? "/" + u : u;
}
function Qa(e, t) {
  let u = "", s = 0, r = -1, o = 0, E = -1, T, p;
  for (; ++E <= e.length; ) {
    if (E < e.length)
      T = e.codePointAt(E);
    else {
      if (T === 47)
        break;
      T = 47;
    }
    if (T === 47) {
      if (!(r === E - 1 || o === 1))
        if (r !== E - 1 && o === 2) {
          if (u.length < 2 || s !== 2 || u.codePointAt(u.length - 1) !== 46 || u.codePointAt(u.length - 2) !== 46) {
            if (u.length > 2) {
              if (p = u.lastIndexOf("/"), p !== u.length - 1) {
                p < 0 ? (u = "", s = 0) : (u = u.slice(0, p), s = u.length - 1 - u.lastIndexOf("/")), r = E, o = 0;
                continue;
              }
            } else if (u.length > 0) {
              u = "", s = 0, r = E, o = 0;
              continue;
            }
          }
          t && (u = u.length > 0 ? u + "/.." : "..", s = 2);
        } else
          u.length > 0 ? u += "/" + e.slice(r + 1, E) : u = e.slice(r + 1, E), s = E - r - 1;
      r = E, o = 0;
    } else
      T === 46 && o > -1 ? o++ : o = -1;
  }
  return u;
}
function Ce(e) {
  if (typeof e != "string")
    throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
}
const Xa = { cwd: Ka };
function Ka() {
  return "/";
}
function ze(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && e.auth === void 0);
}
function Va(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!ze(e)) {
    const t = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + e + "`");
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return za(e);
}
function za(e) {
  if (e.hostname !== "") {
    const s = new TypeError('File URL host must be "localhost" or empty on darwin');
    throw s.code = "ERR_INVALID_FILE_URL_HOST", s;
  }
  const t = e.pathname;
  let u = -1;
  for (; ++u < t.length; )
    if (t.codePointAt(u) === 37 && t.codePointAt(u + 1) === 50) {
      const s = t.codePointAt(u + 2);
      if (s === 70 || s === 102) {
        const r = new TypeError("File URL path must not include encoded / characters");
        throw r.code = "ERR_INVALID_FILE_URL_PATH", r;
      }
    }
  return decodeURIComponent(t);
}
const we = ["history", "path", "basename", "stem", "extname", "dirname"];
class Rt {
  constructor(t) {
    let u;
    t ? ze(t) ? u = { path: t } : typeof t == "string" || ja(t) ? u = { value: t } : u = t : u = {}, this.cwd = Xa.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let s = -1;
    for (; ++s < we.length; ) {
      const o = we[s];
      o in u && u[o] !== void 0 && u[o] !== null && (this[o] = o === "history" ? [...u[o]] : u[o]);
    }
    let r;
    for (r in u)
      we.includes(r) || (this[r] = u[r]);
  }
  get basename() {
    return typeof this.path == "string" ? H.basename(this.path) : void 0;
  }
  set basename(t) {
    ve(t, "basename"), Ge(t, "basename"), this.path = H.join(this.dirname || "", t);
  }
  get dirname() {
    return typeof this.path == "string" ? H.dirname(this.path) : void 0;
  }
  set dirname(t) {
    Ot(this.basename, "dirname"), this.path = H.join(t || "", this.basename);
  }
  get extname() {
    return typeof this.path == "string" ? H.extname(this.path) : void 0;
  }
  set extname(t) {
    if (Ge(t, "extname"), Ot(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = H.join(this.dirname, this.stem + (t || ""));
  }
  get path() {
    return this.history[this.history.length - 1];
  }
  set path(t) {
    ze(t) && (t = Va(t)), ve(t, "path"), this.path !== t && this.history.push(t);
  }
  get stem() {
    return typeof this.path == "string" ? H.basename(this.path, this.extname) : void 0;
  }
  set stem(t) {
    ve(t, "stem"), Ge(t, "stem"), this.path = H.join(this.dirname || "", t + (this.extname || ""));
  }
  fail(t, u, s) {
    const r = this.message(t, u, s);
    throw r.fatal = !0, r;
  }
  info(t, u, s) {
    const r = this.message(t, u, s);
    return r.fatal = void 0, r;
  }
  message(t, u, s) {
    const r = new O(t, u, s);
    return this.path && (r.name = this.path + ":" + r.name, r.file = this.path), r.fatal = !1, this.messages.push(r), r;
  }
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function Ge(e, t) {
  if (e && e.includes(H.sep))
    throw new Error("`" + t + "` cannot be a path: did not expect `" + H.sep + "`");
}
function ve(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Ot(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function ja(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const Ja = { abandonedHeadElementChild: { reason: "Unexpected metadata element after head", description: "Unexpected element after head. Expected the element before `</head>`", url: !1 }, abruptClosingOfEmptyComment: { reason: "Unexpected abruptly closed empty comment", description: "Unexpected `>` or `->`. Expected `-->` to close comments" }, abruptDoctypePublicIdentifier: { reason: "Unexpected abruptly closed public identifier", description: "Unexpected `>`. Expected a closing `\"` or `'` after the public identifier" }, abruptDoctypeSystemIdentifier: { reason: "Unexpected abruptly closed system identifier", description: "Unexpected `>`. Expected a closing `\"` or `'` after the identifier identifier" }, absenceOfDigitsInNumericCharacterReference: { reason: "Unexpected non-digit at start of numeric character reference", description: "Unexpected `%c`. Expected `[0-9]` for decimal references or `[0-9a-fA-F]` for hexadecimal references" }, cdataInHtmlContent: { reason: "Unexpected CDATA section in HTML", description: "Unexpected `<![CDATA[` in HTML. Remove it, use a comment, or encode special characters instead" }, characterReferenceOutsideUnicodeRange: { reason: "Unexpected too big numeric character reference", description: "Unexpectedly high character reference. Expected character references to be at most hexadecimal 10ffff (or decimal 1114111)" }, closingOfElementWithOpenChildElements: { reason: "Unexpected closing tag with open child elements", description: "Unexpectedly closing tag. Expected other tags to be closed first", url: !1 }, controlCharacterInInputStream: { reason: "Unexpected control character", description: "Unexpected control character `%x`. Expected a non-control code point, 0x00, or ASCII whitespace" }, controlCharacterReference: { reason: "Unexpected control character reference", description: "Unexpectedly control character in reference. Expected a non-control code point, 0x00, or ASCII whitespace" }, disallowedContentInNoscriptInHead: { reason: "Disallowed content inside `<noscript>` in `<head>`", description: "Unexpected text character `%c`. Only use text in `<noscript>`s in `<body>`", url: !1 }, duplicateAttribute: { reason: "Unexpected duplicate attribute", description: "Unexpectedly double attribute. Expected attributes to occur only once" }, endTagWithAttributes: { reason: "Unexpected attribute on closing tag", description: "Unexpected attribute. Expected `>` instead" }, endTagWithTrailingSolidus: { reason: "Unexpected slash at end of closing tag", description: "Unexpected `%c-1`. Expected `>` instead" }, endTagWithoutMatchingOpenElement: { reason: "Unexpected unopened end tag", description: "Unexpected end tag. Expected no end tag or another end tag", url: !1 }, eofBeforeTagName: { reason: "Unexpected end of file", description: "Unexpected end of file. Expected tag name instead" }, eofInCdata: { reason: "Unexpected end of file in CDATA", description: "Unexpected end of file. Expected `]]>` to close the CDATA" }, eofInComment: { reason: "Unexpected end of file in comment", description: "Unexpected end of file. Expected `-->` to close the comment" }, eofInDoctype: { reason: "Unexpected end of file in doctype", description: "Unexpected end of file. Expected a valid doctype (such as `<!doctype html>`)" }, eofInElementThatCanContainOnlyText: { reason: "Unexpected end of file in element that can only contain text", description: "Unexpected end of file. Expected text or a closing tag", url: !1 }, eofInScriptHtmlCommentLikeText: { reason: "Unexpected end of file in comment inside script", description: "Unexpected end of file. Expected `-->` to close the comment" }, eofInTag: { reason: "Unexpected end of file in tag", description: "Unexpected end of file. Expected `>` to close the tag" }, incorrectlyClosedComment: { reason: "Incorrectly closed comment", description: "Unexpected `%c-1`. Expected `-->` to close the comment" }, incorrectlyOpenedComment: { reason: "Incorrectly opened comment", description: "Unexpected `%c`. Expected `<!--` to open the comment" }, invalidCharacterSequenceAfterDoctypeName: { reason: "Invalid sequence after doctype name", description: "Unexpected sequence at `%c`. Expected `public` or `system`" }, invalidFirstCharacterOfTagName: { reason: "Invalid first character in tag name", description: "Unexpected `%c`. Expected an ASCII letter instead" }, misplacedDoctype: { reason: "Misplaced doctype", description: "Unexpected doctype. Expected doctype before head", url: !1 }, misplacedStartTagForHeadElement: { reason: "Misplaced `<head>` start tag", description: "Unexpected start tag `<head>`. Expected `<head>` directly after doctype", url: !1 }, missingAttributeValue: { reason: "Missing attribute value", description: "Unexpected `%c-1`. Expected an attribute value or no `%c-1` instead" }, missingDoctype: { reason: "Missing doctype before other content", description: "Expected a `<!doctype html>` before anything else", url: !1 }, missingDoctypeName: { reason: "Missing doctype name", description: "Unexpected doctype end at `%c`. Expected `html` instead" }, missingDoctypePublicIdentifier: { reason: "Missing public identifier in doctype", description: "Unexpected `%c`. Expected identifier for `public` instead" }, missingDoctypeSystemIdentifier: { reason: "Missing system identifier in doctype", description: 'Unexpected `%c`. Expected identifier for `system` instead (suggested: `"about:legacy-compat"`)' }, missingEndTagName: { reason: "Missing name in end tag", description: "Unexpected `%c`. Expected an ASCII letter instead" }, missingQuoteBeforeDoctypePublicIdentifier: { reason: "Missing quote before public identifier in doctype", description: "Unexpected `%c`. Expected `\"` or `'` instead" }, missingQuoteBeforeDoctypeSystemIdentifier: { reason: "Missing quote before system identifier in doctype", description: "Unexpected `%c`. Expected `\"` or `'` instead" }, missingSemicolonAfterCharacterReference: { reason: "Missing semicolon after character reference", description: "Unexpected `%c`. Expected `;` instead" }, missingWhitespaceAfterDoctypePublicKeyword: { reason: "Missing whitespace after public identifier in doctype", description: "Unexpected `%c`. Expected ASCII whitespace instead" }, missingWhitespaceAfterDoctypeSystemKeyword: { reason: "Missing whitespace after system identifier in doctype", description: "Unexpected `%c`. Expected ASCII whitespace instead" }, missingWhitespaceBeforeDoctypeName: { reason: "Missing whitespace before doctype name", description: "Unexpected `%c`. Expected ASCII whitespace instead" }, missingWhitespaceBetweenAttributes: { reason: "Missing whitespace between attributes", description: "Unexpected `%c`. Expected ASCII whitespace instead" }, missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: { reason: "Missing whitespace between public and system identifiers in doctype", description: "Unexpected `%c`. Expected ASCII whitespace instead" }, nestedComment: { reason: "Unexpected nested comment", description: "Unexpected `<!--`. Expected `-->`" }, nestedNoscriptInHead: { reason: "Unexpected nested `<noscript>` in `<head>`", description: "Unexpected `<noscript>`. Expected a closing tag or a meta element", url: !1 }, nonConformingDoctype: { reason: "Unexpected non-conforming doctype declaration", description: 'Expected `<!doctype html>` or `<!doctype html system "about:legacy-compat">`', url: !1 }, nonVoidHtmlElementStartTagWithTrailingSolidus: { reason: "Unexpected trailing slash on start tag of non-void element", description: "Unexpected `/`. Expected `>` instead" }, noncharacterCharacterReference: { reason: "Unexpected noncharacter code point referenced by character reference", description: "Unexpected code point. Do not use noncharacters in HTML" }, noncharacterInInputStream: { reason: "Unexpected noncharacter character", description: "Unexpected code point `%x`. Do not use noncharacters in HTML" }, nullCharacterReference: { reason: "Unexpected NULL character referenced by character reference", description: "Unexpected code point. Do not use NULL characters in HTML" }, openElementsLeftAfterEof: { reason: "Unexpected end of file", description: "Unexpected end of file. Expected closing tag instead", url: !1 }, surrogateCharacterReference: { reason: "Unexpected surrogate character referenced by character reference", description: "Unexpected code point. Do not use lone surrogate characters in HTML" }, surrogateInInputStream: { reason: "Unexpected surrogate character", description: "Unexpected code point `%x`. Do not use lone surrogate characters in HTML" }, unexpectedCharacterAfterDoctypeSystemIdentifier: { reason: "Invalid character after system identifier in doctype", description: "Unexpected character at `%c`. Expected `>`" }, unexpectedCharacterInAttributeName: { reason: "Unexpected character in attribute name", description: "Unexpected `%c`. Expected whitespace, `/`, `>`, `=`, or probably an ASCII letter" }, unexpectedCharacterInUnquotedAttributeValue: { reason: "Unexpected character in unquoted attribute value", description: "Unexpected `%c`. Quote the attribute value to include it" }, unexpectedEqualsSignBeforeAttributeName: { reason: "Unexpected equals sign before attribute name", description: "Unexpected `%c`. Add an attribute name before it" }, unexpectedNullCharacter: { reason: "Unexpected NULL character", description: "Unexpected code point `%x`. Do not use NULL characters in HTML" }, unexpectedQuestionMarkInsteadOfTagName: { reason: "Unexpected question mark instead of tag name", description: "Unexpected `%c`. Expected an ASCII letter instead" }, unexpectedSolidusInTag: { reason: "Unexpected slash in tag", description: "Unexpected `%c-1`. Expected it followed by `>` or in a quoted attribute value" }, unknownNamedCharacterReference: { reason: "Unexpected unknown named character reference", description: "Unexpected character reference. Expected known named character references" } }, Za = "https://html.spec.whatwg.org/multipage/parsing.html#parse-error-", $a = /-[a-z]/g, er = /%c(?:([-+])(\d+))?/g, tr = /%x/g, ur = { 2: !0, 1: !1, 0: null }, nr = {};
function Lt(e, t) {
  const u = t || nr, s = u.onerror, r = e instanceof Rt ? e : new Rt(e), o = u.fragment ? wa : Ha, E = String(r), T = o(E, { sourceCodeLocationInfo: !0, onParseError: u.onerror ? p : null, scriptingEnabled: !1 });
  return rn(T, { file: r, space: u.space, verbose: u.verbose });
  function p(D) {
    const m = D.code, F = sr(m), M = u[F], z = M ?? !0, ot = typeof z == "number" ? z : z ? 1 : 0;
    if (ot) {
      const ue = Ja[F], G = new O(ct(ue.reason), { place: { start: { line: D.startLine, column: D.startCol, offset: D.startOffset }, end: { line: D.endLine, column: D.endCol, offset: D.endOffset } }, ruleId: m, source: "hast-util-from-html" });
      r.path && (G.file = r.path, G.name = r.path + ":" + G.name), G.fatal = ur[ot], G.note = ct(ue.description), G.url = ue.url === !1 ? void 0 : Za + m, s(G);
    }
    function ct(ue) {
      return ue.replace(er, G).replace(tr, Pu);
      function G(Sr, xu, Et) {
        const yu = (Et ? Number.parseInt(Et, 10) : 0) * (xu === "-" ? -1 : 1), Uu = E.charAt(D.startOffset + yu);
        return rr(Uu);
      }
      function Pu() {
        return ir(E.charCodeAt(D.startOffset));
      }
    }
  }
}
function sr(e) {
  return e.replace($a, ar);
}
function ar(e) {
  return e.charAt(1).toUpperCase();
}
function rr(e) {
  return e === "`" ? "` ` `" : e;
}
function ir(e) {
  return "0x" + e.toString(16).toUpperCase();
}
const Fu = -1, be = 0, ge = 1, Fe = 2, st = 3, at = 4, rt = 5, it = 6, Ru = 7, Ou = 8, kt = typeof self == "object" ? self : globalThis, or = (e, t) => {
  const u = (r, o) => (e.set(o, r), r), s = (r) => {
    if (e.has(r))
      return e.get(r);
    const [o, E] = t[r];
    switch (o) {
      case be:
      case Fu:
        return u(E, r);
      case ge: {
        const T = u([], r);
        for (const p of E)
          T.push(s(p));
        return T;
      }
      case Fe: {
        const T = u({}, r);
        for (const [p, D] of E)
          T[s(p)] = s(D);
        return T;
      }
      case st:
        return u(new Date(E), r);
      case at: {
        const { source: T, flags: p } = E;
        return u(new RegExp(T, p), r);
      }
      case rt: {
        const T = u(/* @__PURE__ */ new Map(), r);
        for (const [p, D] of E)
          T.set(s(p), s(D));
        return T;
      }
      case it: {
        const T = u(/* @__PURE__ */ new Set(), r);
        for (const p of E)
          T.add(s(p));
        return T;
      }
      case Ru: {
        const { name: T, message: p } = E;
        return u(new kt[T](p), r);
      }
      case Ou:
        return u(BigInt(E), r);
      case "BigInt":
        return u(Object(BigInt(E)), r);
    }
    return u(new kt[o](E), r);
  };
  return s;
}, Mt = (e) => or(/* @__PURE__ */ new Map(), e)(0), j = "", { toString: cr } = {}, { keys: Er } = Object, ae = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [be, t];
  const u = cr.call(e).slice(8, -1);
  switch (u) {
    case "Array":
      return [ge, j];
    case "Object":
      return [Fe, j];
    case "Date":
      return [st, j];
    case "RegExp":
      return [at, j];
    case "Map":
      return [rt, j];
    case "Set":
      return [it, j];
  }
  return u.includes("Array") ? [ge, u] : u.includes("Error") ? [Ru, u] : [Fe, u];
}, fe = ([e, t]) => e === be && (t === "function" || t === "symbol"), lr = (e, t, u, s) => {
  const r = (E, T) => {
    const p = s.push(E) - 1;
    return u.set(T, p), p;
  }, o = (E) => {
    if (u.has(E))
      return u.get(E);
    let [T, p] = ae(E);
    switch (T) {
      case be: {
        let m = E;
        switch (p) {
          case "bigint":
            T = Ou, m = E.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + p);
            m = null;
            break;
          case "undefined":
            return r([Fu], E);
        }
        return r([T, m], E);
      }
      case ge: {
        if (p)
          return r([p, [...E]], E);
        const m = [], F = r([T, m], E);
        for (const M of E)
          m.push(o(M));
        return F;
      }
      case Fe: {
        if (p)
          switch (p) {
            case "BigInt":
              return r([p, E.toString()], E);
            case "Boolean":
            case "Number":
            case "String":
              return r([p, E.valueOf()], E);
          }
        if (t && "toJSON" in E)
          return o(E.toJSON());
        const m = [], F = r([T, m], E);
        for (const M of Er(E))
          (e || !fe(ae(E[M]))) && m.push([o(M), o(E[M])]);
        return F;
      }
      case st:
        return r([T, E.toISOString()], E);
      case at: {
        const { source: m, flags: F } = E;
        return r([T, { source: m, flags: F }], E);
      }
      case rt: {
        const m = [], F = r([T, m], E);
        for (const [M, z] of E)
          (e || !(fe(ae(M)) || fe(ae(z)))) && m.push([o(M), o(z)]);
        return F;
      }
      case it: {
        const m = [], F = r([T, m], E);
        for (const M of E)
          (e || !fe(ae(M))) && m.push(o(M));
        return F;
      }
    }
    const { message: D } = E;
    return r([T, { name: p, message: D }], E);
  };
  return o;
}, bt = (e, { json: t, lossy: u } = {}) => {
  const s = [];
  return lr(!(t || u), !!t, /* @__PURE__ */ new Map(), s)(e), s;
}, Ar = typeof structuredClone == "function" ? (e, t) => t && ("json" in t || "lossy" in t) ? Mt(bt(e, t)) : structuredClone(e) : (e, t) => Mt(bt(e, t)), hr = Lu("end"), Tr = Lu("start");
function Lu(e) {
  return t;
  function t(u) {
    const s = u && u.position && u.position[e] || {};
    if (typeof s.line == "number" && s.line > 0 && typeof s.column == "number" && s.column > 0)
      return { line: s.line, column: s.column, offset: typeof s.offset == "number" && s.offset > -1 ? s.offset : void 0 };
  }
}
function pr(e) {
  const t = Tr(e), u = hr(e);
  if (t && u)
    return { start: t, end: u };
}
const Q = ["ariaDescribedBy", "ariaLabel", "ariaLabelledBy"], Pt = { ancestors: { tbody: ["table"], td: ["table"], th: ["table"], thead: ["table"], tfoot: ["table"], tr: ["table"] }, attributes: { a: [...Q, "dataFootnoteBackref", "dataFootnoteRef", ["className", "data-footnote-backref"], "href"], blockquote: ["cite"], code: [["className", /^language-./]], del: ["cite"], div: ["itemScope", "itemType"], dl: [...Q], h2: [["className", "sr-only"]], img: [...Q, "longDesc", "src"], input: [["disabled", !0], ["type", "checkbox"]], ins: ["cite"], li: [["className", "task-list-item"]], ol: [...Q, ["className", "contains-task-list"]], q: ["cite"], section: ["dataFootnotes", ["className", "footnotes"]], source: ["srcSet"], summary: [...Q], table: [...Q], ul: [...Q, ["className", "contains-task-list"]], "*": ["abbr", "accept", "acceptCharset", "accessKey", "action", "align", "alt", "axis", "border", "cellPadding", "cellSpacing", "char", "charOff", "charSet", "checked", "clear", "colSpan", "color", "cols", "compact", "coords", "dateTime", "dir", "encType", "frame", "hSpace", "headers", "height", "hrefLang", "htmlFor", "id", "isMap", "itemProp", "label", "lang", "maxLength", "media", "method", "multiple", "name", "noHref", "noShade", "noWrap", "open", "prompt", "readOnly", "rev", "rowSpan", "rows", "rules", "scope", "selected", "shape", "size", "span", "start", "summary", "tabIndex", "title", "useMap", "vAlign", "value", "width"] }, clobber: ["ariaDescribedBy", "ariaLabelledBy", "id", "name"], clobberPrefix: "user-content-", protocols: { cite: ["http", "https"], href: ["http", "https", "irc", "ircs", "mailto", "xmpp"], longDesc: ["http", "https"], src: ["http", "https"] }, required: { input: { disabled: !0, type: "checkbox" } }, strip: ["script"], tagNames: ["a", "b", "blockquote", "br", "code", "dd", "del", "details", "div", "dl", "dt", "em", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "input", "ins", "kbd", "li", "ol", "p", "picture", "pre", "q", "rp", "rt", "ruby", "s", "samp", "section", "source", "span", "strike", "strong", "sub", "summary", "sup", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "tt", "ul", "var"] }, q = {}.hasOwnProperty;
function dr(e, t) {
  let u = { type: "root", children: [] };
  const s = { schema: t ? { ...Pt, ...t } : Pt, stack: [] }, r = ku(s, e);
  return r && (Array.isArray(r) ? r.length === 1 ? u = r[0] : u.children = r : u = r), u;
}
function ku(e, t) {
  if (t && typeof t == "object") {
    const u = t;
    switch (typeof u.type == "string" ? u.type : "") {
      case "comment":
        return Cr(e, u);
      case "doctype":
        return Dr(e, u);
      case "element":
        return mr(e, u);
      case "root":
        return _r(e, u);
      case "text":
        return fr(e, u);
    }
  }
}
function Cr(e, t) {
  if (e.schema.allowComments) {
    const u = typeof t.value == "string" ? t.value : "", s = u.indexOf("-->"), r = { type: "comment", value: s < 0 ? u : u.slice(0, s) };
    return De(r, t), r;
  }
}
function Dr(e, t) {
  if (e.schema.allowDoctypes) {
    const u = { type: "doctype" };
    return De(u, t), u;
  }
}
function mr(e, t) {
  const u = typeof t.tagName == "string" ? t.tagName : "";
  e.stack.push(u);
  const s = Mu(e, t.children), r = Br(e, t.properties);
  e.stack.pop();
  let o = !1;
  if (u && u !== "*" && (!e.schema.tagNames || e.schema.tagNames.includes(u)) && (o = !0, e.schema.ancestors && q.call(e.schema.ancestors, u))) {
    const T = e.schema.ancestors[u];
    let p = -1;
    for (o = !1; ++p < T.length; )
      e.stack.includes(T[p]) && (o = !0);
  }
  if (!o)
    return e.schema.strip && !e.schema.strip.includes(u) ? s : void 0;
  const E = { type: "element", tagName: u, properties: r, children: s };
  return De(E, t), E;
}
function _r(e, t) {
  const u = { type: "root", children: Mu(e, t.children) };
  return De(u, t), u;
}
function fr(e, t) {
  const u = { type: "text", value: typeof t.value == "string" ? t.value : "" };
  return De(u, t), u;
}
function Mu(e, t) {
  const u = [];
  if (Array.isArray(t)) {
    const s = t;
    let r = -1;
    for (; ++r < s.length; ) {
      const o = ku(e, s[r]);
      o && (Array.isArray(o) ? u.push(...o) : u.push(o));
    }
  }
  return u;
}
function Br(e, t) {
  const u = e.stack[e.stack.length - 1], s = e.schema.attributes, r = e.schema.required, o = s && q.call(s, u) ? s[u] : void 0, E = s && q.call(s, "*") ? s["*"] : void 0, T = t && typeof t == "object" ? t : {}, p = {};
  let D;
  for (D in T)
    if (q.call(T, D)) {
      const m = T[D];
      let F = xt(e, yt(o, D), D, m);
      F == null && (F = xt(e, yt(E, D), D, m)), F != null && (p[D] = F);
    }
  if (r && q.call(r, u)) {
    const m = r[u];
    for (D in m)
      q.call(m, D) && !q.call(p, D) && (p[D] = m[D]);
  }
  return p;
}
function xt(e, t, u, s) {
  return t ? Array.isArray(s) ? Ir(e, t, u, s) : bu(e, t, u, s) : void 0;
}
function Ir(e, t, u, s) {
  let r = -1;
  const o = [];
  for (; ++r < s.length; ) {
    const E = bu(e, t, u, s[r]);
    (typeof E == "number" || typeof E == "string") && o.push(E);
  }
  return o;
}
function bu(e, t, u, s) {
  if (!(typeof s != "boolean" && typeof s != "number" && typeof s != "string") && Nr(e, u, s)) {
    if (typeof t == "object" && t.length > 1) {
      let r = !1, o = 0;
      for (; ++o < t.length; ) {
        const E = t[o];
        if (E && typeof E == "object" && "flags" in E) {
          if (E.test(String(s))) {
            r = !0;
            break;
          }
        } else if (E === s) {
          r = !0;
          break;
        }
      }
      if (!r)
        return;
    }
    return e.schema.clobber && e.schema.clobberPrefix && e.schema.clobber.includes(u) ? e.schema.clobberPrefix + s : s;
  }
}
function Nr(e, t, u) {
  const s = e.schema.protocols && q.call(e.schema.protocols, t) ? e.schema.protocols[t] : void 0;
  if (!s || s.length === 0)
    return !0;
  const r = String(u), o = r.indexOf(":"), E = r.indexOf("?"), T = r.indexOf("#"), p = r.indexOf("/");
  if (o < 0 || p > -1 && o > p || E > -1 && o > E || T > -1 && o > T)
    return !0;
  let D = -1;
  for (; ++D < s.length; ) {
    const m = s[D];
    if (o === m.length && r.slice(0, m.length) === m)
      return !0;
  }
  return !1;
}
function De(e, t) {
  const u = pr(t);
  t.data && (e.data = Ar(t.data)), u && (e.position = u);
}
function yt(e, t) {
  let u, s = -1;
  if (e)
    for (; ++s < e.length; ) {
      const r = e[s], o = typeof r == "string" ? r : r[0];
      if (o === t)
        return r;
      o === "data*" && (u = r);
    }
  if (t.length > 4 && t.slice(0, 4).toLowerCase() === "data")
    return u;
}
const Fr = (e, t, u) => t ? Lt(e, u) : dr(Lt(e, u));
export {
  Fr as fromHTMLStringToHast
};
